<mat-toolbar class="text-uppercase">
  <mat-toolbar-row>
    <span>Monitor</span>
    <span class="spacer"></span>
    <button mat-raised-button color="primary" (click)="export()">
      Exportar
    </button>
  </mat-toolbar-row>
</mat-toolbar>

<mat-accordion>
  <form #thisForm="ngForm">
    <mat-card>
      <mat-card-header> </mat-card-header>
      <mat-card-content class="container-fluid">
        <div class="row mb-2">
          <div class="col-3">
            <mat-form-field>
              <mat-label>Tipo de Filtro</mat-label>
              <mat-select
                [(ngModel)]="monitorFilter.dateType"
                name="dateType"
                (ngModelChange)="dateTypeFilterChange()"
              >
                <mat-option
                  *ngFor="let item of filterDateTypes"
                  [value]="item.value"
                >
                  {{ item.name }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="col-3" [class.has-error]="periodoError()">
            <mat-form-field>
              <input
                matInput
                name="periodoDe"
                [(ngModel)]="monitorFilter.fromDate"
                [matDatepicker]="picker"
                placeholder="Do dia"
              />
              <mat-datepicker-toggle matSuffix [for]="picker">
              </mat-datepicker-toggle>
              <mat-datepicker #picker></mat-datepicker>
            </mat-form-field>
          </div>
          <div class="col-3" [class.has-error]="periodoError()">
            <mat-form-field>
              <input
                matInput
                name="periodoAte"
                [(ngModel)]="monitorFilter.untilDate"
                [matDatepicker]="picker2"
                placeholder="Até o dia"
              />
              <mat-datepicker-toggle matSuffix [for]="picker2">
              </mat-datepicker-toggle>
              <mat-datepicker #picker2></mat-datepicker>
            </mat-form-field>
          </div>
          <div class="col-3">
            <mat-form-field>
              <mat-label>No. da Boleta</mat-label>
              <input
                matInput
                type="text"
                placeholder="ID Boleta"
                [(ngModel)]="monitorFilter.ticketId"
                name="IDBoleta"
              />
            </mat-form-field>
          </div>
        </div>
        <div class="row mb-2">
          <div class="col-3">
            <mat-form-field>
              <mat-label>Tipo de Operação</mat-label>
              <mat-select
                [(ngModel)]="monitorFilter.operationTypeId"
                name="operationTypeId"
              >
                <mat-option [value]="null"> (todos) </mat-option>
                <mat-option
                  *ngFor="let item of ListOperationTypes"
                  [value]="item.id"
                >
                  {{ item.name }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="col-3">
            <mat-form-field>
              <mat-label>Tipo de Liquidação</mat-label>
              <mat-select
                [(ngModel)]="monitorFilter.settlementTypeId"
                name="settlementTypeId"
              >
                <mat-option [value]="null"> (todos) </mat-option>
                <mat-option
                  *ngFor="let item of ListSettlementTypes"
                  [value]="item.id"
                >
                  {{ item.name }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="col-3">
            <mat-form-field>
              <mat-label>Status</mat-label>
              <mat-select
                [(ngModel)]="monitorFilter.statusId"
                name="workflowStatus"
                [disabled]="statusFilterDisabled()"
              >
                <mat-option [value]="null"> (todos) </mat-option>
                <mat-option
                  *ngFor="let item of WorkflowStatus"
                  [value]="item.id"
                >
                  {{ item.name }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="col-3">
            <mat-form-field>
              <mat-label>Boleta</mat-label>
              <mat-select
                [(ngModel)]="monitorFilter.ticketType"
                name="ticketType"
              >
                <mat-option [value]="null"> (todas) </mat-option>
                <mat-option *ngFor="let item of TicketTypes" [value]="item.id">
                  {{ item.name }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
        <div class="row mb-2" *ngIf="!isAccountManager()">
          <div class="col-12">
            <mat-form-field>
              <input
                type="text"
                matInput
                placeholder="Gestor"
                [(ngModel)]="AccountManagerSelected"
                name="accountManager"
                [matAutocomplete]="auto"
              />
              <mat-autocomplete
                #auto="matAutocomplete"
                [displayWith]="exibeNomeAccountManager"
              >
                <mat-option
                  *ngFor="let item of filteredAccountManagers | async"
                  (click)="onAccManagerSelected(item)"
                  [value]="item"
                >
                  {{ item.document + " " + item.name }}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>
          </div>
        </div>
        <div class="row mb-2">
          <div class="col-5">
            <mat-form-field>
              <input
                matInput
                type="text"
                placeholder="Nome do Fundo"
                [(ngModel)]="monitorFilter.fundName"
                name="nomeFundo"
              />
            </mat-form-field>
          </div>
          <div class="col-3">
            <mat-form-field>
              <input
                matInput
                type="text"
                placeholder="CNPJ"
                [(ngModel)]="monitorFilter.fundCnpj"
                name="cnpj"
                pattern="\d{2}[.]\d{3}[.]\d{3}\/\d{4}-\d{2}"
                [textMask]="{
                  mask: validator.documentLegalPersonMask,
                  guide: false
                }"
              />
            </mat-form-field>
          </div>
          <div class="col-2">
            <button
              style="width: 100%"
              mat-raised-button
              color="primary"
              type="button"
              (click)="clear()"
            >
              Limpar
            </button>
          </div>
          <div class="col-2">
            <button
              style="width: 100%"
              mat-raised-button
              color="primary"
              type="submit"
              (click)="filter()"
            >
              Buscar
            </button>
          </div>
        </div>
      </mat-card-content>
    </mat-card>
  </form>
  <br />
  <mat-expansion-panel
    *ngIf="canDisplay(TicketTypeEnum.Quota)"
    [expanded]="this.ActiveTicketId == TicketTypeEnum.Quota"
  >
    <mat-expansion-panel-header>
      Cotas - ({{ this.Quotas ? this.quotaTotalItems : 0 }})
    </mat-expansion-panel-header>
    <mat-action-row>
      <button
        *ngIf="hasForwardRole(TicketTypeEnum.Quota)"
        mat-raised-button
        color="primary"
        type="submit"
        (click)="forwardMany(TicketTypeEnum.Quota)"
      >
        Encaminhar
      </button>
      <button
        *ngIf="hasApproveRole(TicketTypeEnum.Quota)"
        mat-raised-button
        color="primary"
        type="submit"
        (click)="approveManyLiquidation(TicketTypeEnum.Quota)"
      >
        Aprovar
      </button>
      <button
        *ngIf="hasApproveRole(TicketTypeEnum.Quota)"
        mat-raised-button
        class="btn btn-danger me-2"
        type="submit"
        (click)="rejectMany(TicketTypeEnum.Quota)"
      >
        Reprovar
      </button>
    </mat-action-row>

    <div class="table-container">
      <table mat-table [dataSource]="Quotas" class="col-12">
        <!--- Note that these columns can be defined in any order.
            The actual rendered columns are set as a property on the row definition" -->

        <!-- Position Column -->
        <ng-container matColumnDef="id">
          <th mat-header-cell *matHeaderCellDef>Nº</th>
          <td mat-cell *matCellDef="let element">{{ element.id }}</td>
        </ng-container>

        <ng-container matColumnDef="accountManagerName">
          <th mat-header-cell *matHeaderCellDef>Nome do Gestor</th>
          <td mat-cell *matCellDef="let element">
            {{ element.accountManagerName }}
          </td>
        </ng-container>

        <ng-container matColumnDef="accountManagerDocument">
          <th mat-header-cell *matHeaderCellDef>CNPJ Gestor</th>
          <td mat-cell *matCellDef="let element">
            {{ element.accountManagerDocument }}
          </td>
        </ng-container>

        <ng-container matColumnDef="operationDate">
          <th mat-header-cell *matHeaderCellDef>Data Operação</th>
          <td mat-cell *matCellDef="let element">
            {{ element.operationDate | date : "dd/MM/yyyy" }}
          </td>
        </ng-container>

        <ng-container matColumnDef="settlementDate">
          <th mat-header-cell *matHeaderCellDef>Data de Liquidação</th>
          <td mat-cell *matCellDef="let element">
            {{ element.settlementDate | date : "dd/MM/yyyy" }}
          </td>
        </ng-container>

        <ng-container matColumnDef="portfolioName">
          <th mat-header-cell *matHeaderCellDef>Nome do Fundo</th>
          <td mat-cell *matCellDef="let element">
            {{ element.portfolioName }}
          </td>
        </ng-container>

        <ng-container matColumnDef="isInternalFund">
          <th mat-header-cell *matHeaderCellDef>Fundo Interno</th>
          <td mat-cell *matCellDef="let element">
            {{ element.isInternalFund ? "SIM" : "NÃO" }}
          </td>
        </ng-container>

        <ng-container matColumnDef="portfolioDocument">
          <th mat-header-cell *matHeaderCellDef>CNPJ</th>
          <td mat-cell *matCellDef="let element">
            {{ element.portfolioDocument }}
          </td>
        </ng-container>

        <ng-container matColumnDef="portfolioAccount">
          <th mat-header-cell *matHeaderCellDef>Conta Corrente</th>
          <td mat-cell *matCellDef="let element">
            {{ element.portfolioAccount }}
          </td>
        </ng-container>

        <!-- specifics -->

        <ng-container matColumnDef="cetipAccount">
          <th mat-header-cell *matHeaderCellDef>Conta Cetip</th>
          <td mat-cell *matCellDef="let element">
            {{ element.portfolioCetipAccount }}
          </td>
        </ng-container>

        <ng-container matColumnDef="operationTypeId">
          <th mat-header-cell *matHeaderCellDef>Tipo Operação</th>
          <td mat-cell *matCellDef="let element">
            {{ QuotaOperationTypesDescription[element.operationTypeId] }}
          </td>
        </ng-container>

        <ng-container matColumnDef="fundType">
          <th mat-header-cell *matHeaderCellDef>Tipo de Cota do Condomínio</th>
          <td mat-cell *matCellDef="let element">
            {{ element.fundType }}
          </td>
        </ng-container>

        <ng-container matColumnDef="settlementTypeId">
          <th mat-header-cell *matHeaderCellDef>Tipo Liquidação</th>
          <td mat-cell *matCellDef="let element">
            {{ SettlemenTypesDescription[element.settlementTypeId] }}
          </td>
        </ng-container>

        <ng-container matColumnDef="fundName">
          <th mat-header-cell *matHeaderCellDef>Fundo Investido</th>
          <td mat-cell *matCellDef="let element">
            {{ element.fundName }}
          </td>
        </ng-container>

        <ng-container matColumnDef="quotaValue">
          <th mat-header-cell *matHeaderCellDef>Valor da Cota</th>
          <td mat-cell *matCellDef="let element">
            {{ element.quotaValue | currency : "R$" : "symbol" : "1.2-2" }}
          </td>
        </ng-container>

        <ng-container matColumnDef="isCetipVoice">
          <th mat-header-cell *matHeaderCellDef>CETIP Voice</th>
          <td mat-cell *matCellDef="let element">
            {{ element.isCetipVoice ? "SIM" : "NÃO" }}
          </td>
        </ng-container>

        <ng-container matColumnDef="cetipVoiceId">
          <th mat-header-cell *matHeaderCellDef>ID Registro Cetip Voice</th>
          <td mat-cell *matCellDef="let element">
            {{ element.cetipVoiceId }}
          </td>
        </ng-container>

        <ng-container matColumnDef="operationValue">
          <th mat-header-cell *matHeaderCellDef>Valor da Operação</th>
          <td mat-cell *matCellDef="let element">
            {{ element.operationValue | currency : "R$" : "symbol" : "1.2-2" }}
          </td>
        </ng-container>

        <ng-container matColumnDef="amount">
          <th mat-header-cell *matHeaderCellDef>Quantidade</th>
          <td mat-cell *matCellDef="let element">
            {{ element.amount | number }}
          </td>
        </ng-container>

        <ng-container matColumnDef="mnemonicCode">
          <th mat-header-cell *matHeaderCellDef>
            Código Mnemônico / CETIP do Fundo
          </th>
          <td mat-cell *matCellDef="let element">
            {{ element.mnemonicCode }}
          </td>
        </ng-container>

        <ng-container matColumnDef="counterpartName">
          <th mat-header-cell *matHeaderCellDef>Nome Contraparte</th>
          <td mat-cell *matCellDef="let element">
            {{ element.counterpartName }}
          </td>
        </ng-container>

        <ng-container matColumnDef="counterpartCetipAccount">
          <th mat-header-cell *matHeaderCellDef>Conta Cetip Contraparte</th>
          <td mat-cell *matCellDef="let element">
            {{ element.counterpartCetipAccount }}
          </td>
        </ng-container>

        <ng-container matColumnDef="fundBank">
          <th mat-header-cell *matHeaderCellDef>Banco</th>
          <td mat-cell *matCellDef="let element">
            {{ element.fundBank }}
          </td>
        </ng-container>

        <ng-container matColumnDef="fundBranch">
          <th mat-header-cell *matHeaderCellDef>Agência</th>
          <td mat-cell *matCellDef="let element">
            {{ element.fundBranch }}
          </td>
        </ng-container>

        <ng-container matColumnDef="fundAccount">
          <th mat-header-cell *matHeaderCellDef>Conta</th>
          <td mat-cell *matCellDef="let element">
            {{ element.fundAccount }}
          </td>
        </ng-container>

        <ng-container matColumnDef="isNewFund">
          <th mat-header-cell *matHeaderCellDef>É novo fundo no mercado?</th>
          <td mat-cell *matCellDef="let element">
            {{ element.isNewFund ? "SIM" : "NÃO" }}
          </td>
        </ng-container>

        <ng-container matColumnDef="statusId">
          <th mat-header-cell *matHeaderCellDef>Status</th>
          <td mat-cell *matCellDef="let element">
            {{ WorkflowStatusDescription[element.statusId || -1] }}
          </td>
        </ng-container>

        <ng-container matColumnDef="elapsedTime">
          <th mat-header-cell *matHeaderCellDef>Tempo Decorrido</th>
          <td mat-cell *matCellDef="let element">
            <span *ngIf="element.elapsedTime && element.elapsedTime.hours >= 1">
              {{ element.elapsedTime.hours | number : "1.0-0" }}h
            </span>
            <span *ngIf="element.elapsedTime && element.elapsedTime.hours < 1">
              {{ element.elapsedTime.minutes | number : "1.0-0" }}min
            </span>
          </td>
        </ng-container>

        <ng-container matColumnDef="statusElectronicTransferAvailable">
          <th mat-header-cell *matHeaderCellDef>Status TED</th>
          <td mat-cell *matCellDef="let element" class="actions">
            <div *ngIf="element.statusElectronicTransferAvailable">
              <a (click)="transferStatusDialog(element)">
                <fa-icon [icon]="faListAlt" title="Visualizar"></fa-icon>
                {{
                  element.statusElectronicTransferAvailable
                    | scpTicketTransferStatus
                }}
              </a>
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="lastStatusDate">
          <th mat-header-cell *matHeaderCellDef>Última atualização</th>
          <td mat-cell *matCellDef="let element">
            {{ element.lastStatusDate | date : "dd/MM/yyyy HH:mm" }}
          </td>
        </ng-container>

        <ng-container matColumnDef="actions" sticky>
          <th mat-header-cell *matHeaderCellDef>
            <!-- <mat-checkbox (change)="$event ? masterToggle(TicketTypeEnum.Quota) : null"
              [checked]="SelectionQuotas.hasValue() && isAllSelected(TicketTypeEnum.Quota)"
              [indeterminate]="SelectionQuotas.hasValue() && !isAllSelected(TicketTypeEnum.Quota)">
            </mat-checkbox> -->
          </th>
          <td mat-cell *matCellDef="let element" class="actions">
            <div>
              <mat-checkbox
                *ngIf="canCheck(TicketTypeEnum.Quota, element)"
                (click)="$event.stopPropagation()"
                (change)="$event ? SelectionQuotas.toggle(element) : null"
                [checked]="SelectionQuotas.isSelected(element)"
              >
              </mat-checkbox>
              <a [routerLink]="[MenuConstants.Tickets.Quota, element.id]">
                <fa-icon [icon]="faListAlt" title="Visualizar"></fa-icon>
              </a>
            </div>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="ColumnsQuota; sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: ColumnsQuota"></tr>
      </table>
    </div>
    <paginador
      [listedPages]="quotaListedPages"
      [firstItemOnPage]="quotaFirstItemOnPage"
      [lastItemOnPage]="quotaLastItemOnPage"
      [totalPages]="quotaTotalPages"
      [totalItems]="quotaTotalItems"
      [currentPage]="quotaCurrentPage"
      [itemsPerPage]="[10, 25, 50, 100, 200]"
      (onSearch)="loadQuotaPaged($event[0], $event[1])"
    ></paginador>
  </mat-expansion-panel>

  <mat-expansion-panel
    *ngIf="canDisplay(TicketTypeEnum.CETIP)"
    [expanded]="this.ActiveTicketId == TicketTypeEnum.CETIP"
  >
    <mat-expansion-panel-header>
      Renda Fixa - Título Privado - ({{
        this.PrivateFixedIncome ? this.cetipTotalItems : 0
      }})
    </mat-expansion-panel-header>
    <mat-action-row>
      <button
        *ngIf="hasForwardRole(TicketTypeEnum.CETIP)"
        mat-raised-button
        color="primary"
        type="submit"
        (click)="forwardMany(TicketTypeEnum.CETIP)"
      >
        Encaminhar
      </button>
      <button
        *ngIf="hasApproveRole(TicketTypeEnum.CETIP)"
        mat-raised-button
        color="primary"
        type="submit"
        (click)="approveMany(TicketTypeEnum.CETIP)"
      >
        Aprovar
      </button>
      <button
        *ngIf="hasApproveRole(TicketTypeEnum.CETIP)"
        mat-raised-button
        color="primary"
        type="submit"
        (click)="rejectMany(TicketTypeEnum.CETIP)"
      >
        Reprovar
      </button>
    </mat-action-row>

    <div class="table-container">
      <table
        mat-table
        [dataSource]="PrivateFixedIncome"
        class="mat-elevation-z8 col-12"
      >
        <ng-container matColumnDef="id">
          <th mat-header-cell *matHeaderCellDef>Nº</th>
          <td mat-cell *matCellDef="let element">{{ element.id }}</td>
        </ng-container>

        <ng-container matColumnDef="accountManagerName">
          <th mat-header-cell *matHeaderCellDef>Nome do Gestor</th>
          <td mat-cell *matCellDef="let element">
            {{ element.accountManagerName }}
          </td>
        </ng-container>

        <ng-container matColumnDef="accountManagerDocument">
          <th mat-header-cell *matHeaderCellDef>CNPJ Gestor</th>
          <td mat-cell *matCellDef="let element">
            {{ element.accountManagerDocument }}
          </td>
        </ng-container>

        <ng-container matColumnDef="operationDate">
          <th mat-header-cell *matHeaderCellDef>Data Operação</th>
          <td mat-cell *matCellDef="let element">
            {{ element.operationDate | date : "dd/MM/yyyy" }}
          </td>
        </ng-container>

        <ng-container matColumnDef="settlementDate">
          <th mat-header-cell *matHeaderCellDef>Data de Liquidação</th>
          <td mat-cell *matCellDef="let element">
            {{ element.settlementDate | date : "dd/MM/yyyy" }}
          </td>
        </ng-container>

        <ng-container matColumnDef="portfolioName">
          <th mat-header-cell *matHeaderCellDef>Nome do Fundo</th>
          <td mat-cell *matCellDef="let element">
            {{ element.portfolioName }}
          </td>
        </ng-container>

        <ng-container matColumnDef="portfolioDocument">
          <th mat-header-cell *matHeaderCellDef>CNPJ</th>
          <td mat-cell *matCellDef="let element">
            {{ element.portfolioDocument }}
          </td>
        </ng-container>

        <ng-container matColumnDef="portfolioAccount">
          <th mat-header-cell *matHeaderCellDef>Conta Corrente</th>
          <td mat-cell *matCellDef="let element">
            {{ element.portfolioAccount }}
          </td>
        </ng-container>

        <!-- specifics -->

        <ng-container matColumnDef="portfolioCetipAccount">
          <th mat-header-cell *matHeaderCellDef>Conta Cetip</th>
          <td mat-cell *matCellDef="let element">
            {{ element.portfolioCetipAccount }}
          </td>
        </ng-container>

        <ng-container matColumnDef="secondaryMarket">
          <th mat-header-cell *matHeaderCellDef>Mercado Secundário</th>
          <td mat-cell *matCellDef="let element">
            {{ element.secondaryMarket ? "SIM" : "NÃO" }}
          </td>
        </ng-container>

        <ng-container matColumnDef="settlementTypeId">
          <th mat-header-cell *matHeaderCellDef>Tipo Liquidação</th>
          <td mat-cell *matCellDef="let element">
            {{ SettlemenTypesDescription[element.settlementTypeId] }}
          </td>
        </ng-container>

        <ng-container matColumnDef="operationTypeId">
          <th mat-header-cell *matHeaderCellDef>Tipo Operação</th>
          <td mat-cell *matCellDef="let element">
            {{ OperationTypesDescription[element.operationTypeId] }}
          </td>
        </ng-container>

        <ng-container matColumnDef="operationValue">
          <th mat-header-cell *matHeaderCellDef>Valor Operação</th>
          <td mat-cell *matCellDef="let element">
            {{ element.operationValue | currency : "R$" : "symbol" : "1.2-2" }}
          </td>
        </ng-container>

        <ng-container matColumnDef="unitPrice">
          <th mat-header-cell *matHeaderCellDef>Preço Unitário</th>
          <td mat-cell *matCellDef="let element">
            {{ element.unitPrice | currency : "R$" : "symbol" : "1.2-2" }}
          </td>
        </ng-container>

        <ng-container matColumnDef="amount">
          <th mat-header-cell *matHeaderCellDef>Quantidade</th>
          <td mat-cell *matCellDef="let element">
            {{ element.amount | number }}
          </td>
        </ng-container>

        <ng-container matColumnDef="assetType">
          <th mat-header-cell *matHeaderCellDef>Tipo Ativo</th>
          <td mat-cell *matCellDef="let element">
            {{ element.assetType }}
          </td>
        </ng-container>

        <ng-container matColumnDef="assetCode">
          <th mat-header-cell *matHeaderCellDef>Código Ativo</th>
          <td mat-cell *matCellDef="let element">
            {{ element.assetCode }}
          </td>
        </ng-container>

        <ng-container matColumnDef="expirationDate">
          <th mat-header-cell *matHeaderCellDef>Data Vencimento</th>
          <td mat-cell *matCellDef="let element">
            {{ element.expirationDate | date : "dd/MM/yyyy" }}
          </td>
        </ng-container>

        <ng-container matColumnDef="counterpartName">
          <th mat-header-cell *matHeaderCellDef>Nome Contraparte</th>
          <td mat-cell *matCellDef="let element">
            {{ element.counterpartName }}
          </td>
        </ng-container>

        <ng-container matColumnDef="counterpartCetipAccount">
          <th mat-header-cell *matHeaderCellDef>Conta CETIP Contraparte</th>
          <td mat-cell *matCellDef="let element">
            {{ element.counterpartCetipAccount }}
          </td>
        </ng-container>

        <ng-container matColumnDef="statusId">
          <th mat-header-cell *matHeaderCellDef>Status</th>
          <td mat-cell *matCellDef="let element">
            {{ WorkflowStatusDescription[element.statusId || -1] }}
          </td>
        </ng-container>

        <ng-container matColumnDef="elapsedTime">
          <th mat-header-cell *matHeaderCellDef>Tempo Decorrido</th>
          <td mat-cell *matCellDef="let element">
            <span *ngIf="element.elapsedTime && element.elapsedTime.hours >= 1">
              {{ element.elapsedTime.hours | number : "1.0-0" }}h
            </span>
            <span *ngIf="element.elapsedTime && element.elapsedTime.hours < 1">
              {{ element.elapsedTime.minutes | number : "1.0-0" }}min
            </span>
          </td>
        </ng-container>

        <ng-container matColumnDef="statusElectronicTransferAvailable">
          <th mat-header-cell *matHeaderCellDef>Status TED</th>
          <td mat-cell *matCellDef="let element" class="actions">
            <div *ngIf="element.statusElectronicTransferAvailable">
              <a (click)="transferStatusDialog(element)">
                <fa-icon [icon]="faListAlt" title="Visualizar"></fa-icon>
                {{
                  element.statusElectronicTransferAvailable
                    | scpTicketTransferStatus
                }}
              </a>
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="lastStatusDate">
          <th mat-header-cell *matHeaderCellDef>Última atualização</th>
          <td mat-cell *matCellDef="let element">
            {{ element.lastStatusDate | date : "dd/MM/yyyy HH:mm" }}
          </td>
        </ng-container>

        <ng-container matColumnDef="actions" sticky>
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let element" class="actions">
            <div>
              <mat-checkbox
                *ngIf="canCheck(TicketTypeEnum.CETIP, element)"
                (click)="$event.stopPropagation()"
                (change)="
                  $event ? SelectionPrivateFixedIncome.toggle(element) : null
                "
                [checked]="SelectionPrivateFixedIncome.isSelected(element)"
              >
              </mat-checkbox>
              <a
                [routerLink]="[
                  MenuConstants.Tickets.PrivateFixedIncome,
                  element.id
                ]"
              >
                <fa-icon [icon]="faListAlt" title="Visualizar"></fa-icon>
              </a>
            </div>
          </td>
        </ng-container>

        <tr
          mat-header-row
          *matHeaderRowDef="ColumnsPrivateFixedIncome; sticky: true"
        ></tr>
        <tr
          mat-row
          *matRowDef="let row; columns: ColumnsPrivateFixedIncome"
        ></tr>
      </table>
    </div>
    <paginador
      [listedPages]="cetipListedPages"
      [firstItemOnPage]="cetipFirstItemOnPage"
      [lastItemOnPage]="cetipLastItemOnPage"
      [totalPages]="cetipTotalPages"
      [totalItems]="cetipTotalItems"
      [currentPage]="cetipCurrentPage"
      [itemsPerPage]="[10, 25, 50, 100, 200]"
      (onSearch)="loadCetipPaged($event[0], $event[1])"
    ></paginador>
  </mat-expansion-panel>

  <mat-expansion-panel
    *ngIf="canDisplay(TicketTypeEnum.SELIC)"
    [expanded]="this.ActiveTicketId == TicketTypeEnum.SELIC"
  >
    <mat-expansion-panel-header>
      Renda Fixa - Título Público - ({{
        this.PublicFixedIncome ? this.selicTotalItems : 0
      }})
    </mat-expansion-panel-header>

    <mat-action-row>
      <button
        *ngIf="hasForwardRole(TicketTypeEnum.SELIC)"
        mat-raised-button
        color="primary"
        type="submit"
        (click)="forwardMany(TicketTypeEnum.SELIC)"
      >
        Encaminhar
      </button>
      <button
        *ngIf="hasApproveRole(TicketTypeEnum.SELIC)"
        mat-raised-button
        color="primary"
        type="submit"
        (click)="approveMany(TicketTypeEnum.SELIC)"
      >
        Aprovar
      </button>
      <button
        *ngIf="hasApproveRole(TicketTypeEnum.SELIC)"
        mat-raised-button
        color="primary"
        type="submit"
        (click)="rejectMany(TicketTypeEnum.SELIC)"
      >
        Reprovar
      </button>
    </mat-action-row>

    <div class="table-container">
      <table
        mat-table
        [dataSource]="PublicFixedIncome"
        class="mat-elevation-z8 col-12"
      >
        <ng-container matColumnDef="id">
          <th mat-header-cell *matHeaderCellDef>Nº</th>
          <td mat-cell *matCellDef="let element">{{ element.id }}</td>
        </ng-container>

        <ng-container matColumnDef="accountManagerName">
          <th mat-header-cell *matHeaderCellDef>Nome do Gestor</th>
          <td mat-cell *matCellDef="let element">
            {{ element.accountManagerName }}
          </td>
        </ng-container>

        <ng-container matColumnDef="accountManagerDocument">
          <th mat-header-cell *matHeaderCellDef>CNPJ Gestor</th>
          <td mat-cell *matCellDef="let element">
            {{ element.accountManagerDocument }}
          </td>
        </ng-container>

        <ng-container matColumnDef="operationDate">
          <th mat-header-cell *matHeaderCellDef>Data Operação</th>
          <td mat-cell *matCellDef="let element">
            {{ element.operationDate | date : "dd/MM/yyyy" }}
          </td>
        </ng-container>

        <ng-container matColumnDef="settlementDate">
          <th mat-header-cell *matHeaderCellDef>Data de Liquidação</th>
          <td mat-cell *matCellDef="let element">
            {{ element.settlementDate | date : "dd/MM/yyyy" }}
          </td>
        </ng-container>

        <ng-container matColumnDef="portfolioName">
          <th mat-header-cell *matHeaderCellDef>Nome do Fundo</th>
          <td mat-cell *matCellDef="let element">
            {{ element.portfolioName }}
          </td>
        </ng-container>

        <ng-container matColumnDef="portfolioDocument">
          <th mat-header-cell *matHeaderCellDef>CNPJ</th>
          <td mat-cell *matCellDef="let element">
            {{ element.portfolioDocument }}
          </td>
        </ng-container>

        <ng-container matColumnDef="portfolioAccount">
          <th mat-header-cell *matHeaderCellDef>Conta Corrente</th>
          <td mat-cell *matCellDef="let element">
            {{ element.portfolioAccount }}
          </td>
        </ng-container>

        <!-- specifics -->

        <ng-container matColumnDef="portfolioSelicAccount">
          <th mat-header-cell *matHeaderCellDef>Conta Selic</th>
          <td mat-cell *matCellDef="let element">
            {{ element.portfolioSelicAccount }}
          </td>
        </ng-container>

        <ng-container matColumnDef="settlementTypeId">
          <th mat-header-cell *matHeaderCellDef>Tipo Liquidação</th>
          <td mat-cell *matCellDef="let element">
            {{ SettlemenTypesDescription[element.settlementTypeId] }}
          </td>
        </ng-container>

        <ng-container matColumnDef="operationTypeId">
          <th mat-header-cell *matHeaderCellDef>Tipo Operação</th>
          <td mat-cell *matCellDef="let element">
            {{ OperationTypesDescription[element.operationTypeId] }}
          </td>
        </ng-container>

        <ng-container matColumnDef="operationValue">
          <th mat-header-cell *matHeaderCellDef>Valor da Operação</th>
          <td mat-cell *matCellDef="let element">
            {{ element.operationValue | currency : "R$" : "symbol" : "1.2-2" }}
          </td>
        </ng-container>

        <ng-container matColumnDef="unitPrice">
          <th mat-header-cell *matHeaderCellDef>Preço Unitário</th>
          <td mat-cell *matCellDef="let element">
            {{ element.unitPrice | currency : "R$" : "symbol" : "1.2-2" }}
          </td>
        </ng-container>

        <ng-container matColumnDef="amount">
          <th mat-header-cell *matHeaderCellDef>Quantidade</th>
          <td mat-cell *matCellDef="let element">
            {{ element.amount | number }}
          </td>
        </ng-container>

        <ng-container matColumnDef="security">
          <th mat-header-cell *matHeaderCellDef>Nome do Título</th>
          <td mat-cell *matCellDef="let element">
            {{ element.security }}
          </td>
        </ng-container>

        <ng-container matColumnDef="securityId">
          <th mat-header-cell *matHeaderCellDef>Código Título</th>
          <td mat-cell *matCellDef="let element">
            {{ element.securityId }}
          </td>
        </ng-container>

        <ng-container matColumnDef="expirationDate">
          <th mat-header-cell *matHeaderCellDef>Data Vencimento</th>
          <td mat-cell *matCellDef="let element">
            {{ element.expirationDate | date : "dd/MM/yyyy" }}
          </td>
        </ng-container>

        <ng-container matColumnDef="counterpartName">
          <th mat-header-cell *matHeaderCellDef>Nome da Contraparte</th>
          <td mat-cell *matCellDef="let element">
            {{ element.counterpartName }}
          </td>
        </ng-container>

        <ng-container matColumnDef="counterpartSelicAccount">
          <th mat-header-cell *matHeaderCellDef>Conta Selic Contraparte</th>
          <td mat-cell *matCellDef="let element">
            {{ element.counterpartSelicAccount }}
          </td>
        </ng-container>

        <ng-container matColumnDef="command">
          <th mat-header-cell *matHeaderCellDef>Comando</th>
          <td mat-cell *matCellDef="let element">
            {{ element.command }}
          </td>
        </ng-container>

        <ng-container matColumnDef="statusId">
          <th mat-header-cell *matHeaderCellDef>Status</th>
          <td mat-cell *matCellDef="let element">
            {{ WorkflowStatusDescription[element.statusId || -1] }}
          </td>
        </ng-container>

        <ng-container matColumnDef="elapsedTime">
          <th mat-header-cell *matHeaderCellDef>Tempo Decorrido</th>
          <td mat-cell *matCellDef="let element">
            <span *ngIf="element.elapsedTime && element.elapsedTime.hours >= 1">
              {{ element.elapsedTime.hours | number : "1.0-0" }}h
            </span>
            <span *ngIf="element.elapsedTime && element.elapsedTime.hours < 1">
              {{ element.elapsedTime.minutes | number : "1.0-0" }}min
            </span>
          </td>
        </ng-container>

        <ng-container matColumnDef="actions" sticky>
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let element" class="actions">
            <div>
              <mat-checkbox
                *ngIf="canCheck(TicketTypeEnum.SELIC, element)"
                (click)="$event.stopPropagation()"
                (change)="
                  $event ? SelectionPublicFixedIncome.toggle(element) : null
                "
                [checked]="SelectionPublicFixedIncome.isSelected(element)"
              >
              </mat-checkbox>
              <a
                [routerLink]="[
                  MenuConstants.Tickets.PublicFixedIncome,
                  element.id
                ]"
              >
                <fa-icon [icon]="faListAlt" title="Visualizar"></fa-icon>
              </a>
            </div>
          </td>
        </ng-container>

        <tr
          mat-header-row
          *matHeaderRowDef="ColumnsPublicFixedIncome; sticky: true"
        ></tr>
        <tr
          mat-row
          *matRowDef="let row; columns: ColumnsPublicFixedIncome"
        ></tr>
      </table>
    </div>
    <paginador
      [listedPages]="selicListedPages"
      [firstItemOnPage]="selicFirstItemOnPage"
      [lastItemOnPage]="selicLastItemOnPage"
      [totalPages]="selicTotalPages"
      [totalItems]="selicTotalItems"
      [currentPage]="selicCurrentPage"
      [itemsPerPage]="[10, 25, 50, 100, 200]"
      (onSearch)="loadSelicPaged($event[0], $event[1])"
    ></paginador>
  </mat-expansion-panel>

  <mat-expansion-panel
    *ngIf="canDisplay(TicketTypeEnum.Contracted)"
    [expanded]="this.ActiveTicketId == TicketTypeEnum.Contracted"
  >
    <mat-expansion-panel-header>
      Compromissada de Compra - ({{
        this.Contracted ? this.contractedTotalItems : 0
      }})
    </mat-expansion-panel-header>

    <mat-action-row>
      <button
        *ngIf="hasForwardRole(TicketTypeEnum.Contracted)"
        mat-raised-button
        color="primary"
        type="submit"
        (click)="forwardMany(TicketTypeEnum.Contracted)"
      >
        Encaminhar
      </button>
      <button
        *ngIf="hasApproveRole(TicketTypeEnum.Contracted)"
        mat-raised-button
        color="primary"
        type="submit"
        (click)="approveMany(TicketTypeEnum.Contracted)"
      >
        Aprovar
      </button>
      <button
        *ngIf="hasApproveRole(TicketTypeEnum.Contracted)"
        mat-raised-button
        color="primary"
        type="submit"
        (click)="rejectMany(TicketTypeEnum.Contracted)"
      >
        Reprovar
      </button>
    </mat-action-row>

    <div class="table-container">
      <table
        mat-table
        [dataSource]="Contracted"
        class="mat-elevation-z8 col-12"
      >
        <ng-container matColumnDef="id">
          <th mat-header-cell *matHeaderCellDef>Nº</th>
          <td mat-cell *matCellDef="let element">{{ element.id }}</td>
        </ng-container>

        <ng-container matColumnDef="accountManagerName">
          <th mat-header-cell *matHeaderCellDef>Nome do Gestor</th>
          <td mat-cell *matCellDef="let element">
            {{ element.accountManagerName }}
          </td>
        </ng-container>

        <ng-container matColumnDef="accountManagerDocument">
          <th mat-header-cell *matHeaderCellDef>CNPJ Gestor</th>
          <td mat-cell *matCellDef="let element">
            {{ element.accountManagerDocument }}
          </td>
        </ng-container>

        <ng-container matColumnDef="operationDate">
          <th mat-header-cell *matHeaderCellDef>Data Operação</th>
          <td mat-cell *matCellDef="let element">
            {{ element.operationDate | date : "dd/MM/yyyy" }}
          </td>
        </ng-container>

        <ng-container matColumnDef="settlementDate">
          <th mat-header-cell *matHeaderCellDef>Data de Liquidação</th>
          <td mat-cell *matCellDef="let element">
            {{ element.settlementDate | date : "dd/MM/yyyy" }}
          </td>
        </ng-container>

        <ng-container matColumnDef="portfolioName">
          <th mat-header-cell *matHeaderCellDef>Nome do Fundo</th>
          <td mat-cell *matCellDef="let element">
            {{ element.portfolioName }}
          </td>
        </ng-container>

        <ng-container matColumnDef="portfolioDocument">
          <th mat-header-cell *matHeaderCellDef>CNPJ</th>
          <td mat-cell *matCellDef="let element">
            {{ element.portfolioDocument }}
          </td>
        </ng-container>

        <ng-container matColumnDef="portfolioAccount">
          <th mat-header-cell *matHeaderCellDef>Conta Corrente</th>
          <td mat-cell *matCellDef="let element">
            {{ element.portfolioAccount }}
          </td>
        </ng-container>

        <!-- specifics -->

        <ng-container matColumnDef="portfolioSelicAccount">
          <th mat-header-cell *matHeaderCellDef>Conta Selic</th>
          <td mat-cell *matCellDef="let element">
            {{ element.portfolioSelicAccount }}
          </td>
        </ng-container>

        <ng-container matColumnDef="returnDate">
          <th mat-header-cell *matHeaderCellDef>Data de Retorno</th>
          <td mat-cell *matCellDef="let element">
            {{ element.returnDate | date : "dd/MM/yyyy" }}
          </td>
        </ng-container>

        <ng-container matColumnDef="valueOutward">
          <th mat-header-cell *matHeaderCellDef>Valor Ida</th>
          <td mat-cell *matCellDef="let element">
            {{ element.valueOutward | currency : "R$" : "symbol" : "1.2-2" }}
          </td>
        </ng-container>

        <ng-container matColumnDef="valueReturn">
          <th mat-header-cell *matHeaderCellDef>Valor Volta</th>
          <td mat-cell *matCellDef="let element">
            {{ element.valueReturn | currency : "R$" : "symbol" : "1.2-2" }}
          </td>
        </ng-container>

        <ng-container matColumnDef="issueTax">
          <th mat-header-cell *matHeaderCellDef>Taxa</th>
          <td mat-cell *matCellDef="let element">
            {{ element.issueTax }}
          </td>
        </ng-container>

        <ng-container matColumnDef="counterpartName">
          <th mat-header-cell *matHeaderCellDef>Nome da Contraparte</th>
          <td mat-cell *matCellDef="let element">
            {{ element.counterpartName }}
          </td>
        </ng-container>

        <ng-container matColumnDef="security">
          <th mat-header-cell *matHeaderCellDef>Nome do Título</th>
          <td mat-cell *matCellDef="let element">
            {{ element.security }}
          </td>
        </ng-container>

        <ng-container matColumnDef="securityId">
          <th mat-header-cell *matHeaderCellDef>Código do Título</th>
          <td mat-cell *matCellDef="let element">
            {{ element.securityId }}
          </td>
        </ng-container>

        <ng-container matColumnDef="expirationDate">
          <th mat-header-cell *matHeaderCellDef>Data Vencimento</th>
          <td mat-cell *matCellDef="let element">
            {{ element.expirationDate | date : "dd/MM/yyyy" }}
          </td>
        </ng-container>

        <ng-container matColumnDef="command">
          <th mat-header-cell *matHeaderCellDef>Comando</th>
          <td mat-cell *matCellDef="let element">
            {{ element.command }}
          </td>
        </ng-container>

        <ng-container matColumnDef="statusId">
          <th mat-header-cell *matHeaderCellDef>Status</th>
          <td mat-cell *matCellDef="let element">
            {{ WorkflowStatusDescription[element.statusId || -1] }}
          </td>
        </ng-container>

        <ng-container matColumnDef="elapsedTime">
          <th mat-header-cell *matHeaderCellDef>Tempo Decorrido</th>
          <td mat-cell *matCellDef="let element">
            <span *ngIf="element.elapsedTime && element.elapsedTime.hours >= 1">
              {{ element.elapsedTime.hours | number : "1.0-0" }}h
            </span>
            <span *ngIf="element.elapsedTime && element.elapsedTime.hours < 1">
              {{ element.elapsedTime.minutes | number : "1.0-0" }}min
            </span>
          </td>
        </ng-container>

        <ng-container matColumnDef="actions" sticky>
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let element" class="actions">
            <div>
              <mat-checkbox
                *ngIf="canCheck(TicketTypeEnum.Contracted, element)"
                (click)="$event.stopPropagation()"
                (change)="$event ? SelectionContracted.toggle(element) : null"
                [checked]="SelectionContracted.isSelected(element)"
              >
              </mat-checkbox>
              <a [routerLink]="[MenuConstants.Tickets.Contracted, element.id]">
                <fa-icon [icon]="faListAlt" title="Visualizar"></fa-icon>
              </a>
            </div>
          </td>
        </ng-container>

        <tr
          mat-header-row
          *matHeaderRowDef="ColumnsContracted; sticky: true"
        ></tr>
        <tr mat-row *matRowDef="let row; columns: ColumnsContracted"></tr>
      </table>
    </div>
    <paginador
      [listedPages]="contractedListedPages"
      [firstItemOnPage]="contractedFirstItemOnPage"
      [lastItemOnPage]="contractedLastItemOnPage"
      [totalPages]="contractedTotalPages"
      [totalItems]="contractedTotalItems"
      [currentPage]="contractedCurrentPage"
      [itemsPerPage]="[10, 25, 50, 100, 200]"
      (onSearch)="loadContractedPaged($event[0], $event[1])"
    ></paginador>
  </mat-expansion-panel>

  <mat-expansion-panel
    *ngIf="canDisplay(TicketTypeEnum.Futures)"
    [expanded]="this.ActiveTicketId == TicketTypeEnum.Futures"
  >
    <mat-expansion-panel-header>
      Futuros - ({{ this.Futures ? this.futuresTotalItems : 0 }})
    </mat-expansion-panel-header>

    <mat-action-row>
      <button
        *ngIf="hasForwardRole(TicketTypeEnum.Futures)"
        mat-raised-button
        color="primary"
        type="submit"
        (click)="forwardMany(TicketTypeEnum.Futures)"
      >
        Encaminhar
      </button>
      <button
        *ngIf="hasApproveRole(TicketTypeEnum.Futures)"
        mat-raised-button
        color="primary"
        type="submit"
        (click)="approveMany(TicketTypeEnum.Futures)"
      >
        Aprovar
      </button>
      <button
        *ngIf="hasApproveRole(TicketTypeEnum.Futures)"
        mat-raised-button
        color="primary"
        type="submit"
        (click)="rejectMany(TicketTypeEnum.Futures)"
      >
        Reprovar
      </button>
    </mat-action-row>

    <div class="table-container">
      <table mat-table [dataSource]="Futures" class="mat-elevation-z8 col-12">
        <ng-container matColumnDef="id">
          <th mat-header-cell *matHeaderCellDef>Nº</th>
          <td mat-cell *matCellDef="let element">{{ element.id }}</td>
        </ng-container>

        <ng-container matColumnDef="accountManagerName">
          <th mat-header-cell *matHeaderCellDef>Nome do Gestor</th>
          <td mat-cell *matCellDef="let element">
            {{ element.accountManagerName }}
          </td>
        </ng-container>

        <ng-container matColumnDef="accountManagerDocument">
          <th mat-header-cell *matHeaderCellDef>CNPJ Gestor</th>
          <td mat-cell *matCellDef="let element">
            {{ element.accountManagerDocument }}
          </td>
        </ng-container>

        <ng-container matColumnDef="operationDate">
          <th mat-header-cell *matHeaderCellDef>Data Operação</th>
          <td mat-cell *matCellDef="let element">
            {{ element.operationDate | date : "dd/MM/yyyy" }}
          </td>
        </ng-container>

        <ng-container matColumnDef="settlementDate">
          <th mat-header-cell *matHeaderCellDef>Data de Liquidação</th>
          <td mat-cell *matCellDef="let element">
            {{ element.settlementDate | date : "dd/MM/yyyy" }}
          </td>
        </ng-container>

        <ng-container matColumnDef="portfolioName">
          <th mat-header-cell *matHeaderCellDef>Nome do Fundo</th>
          <td mat-cell *matCellDef="let element">
            {{ element.portfolioName }}
          </td>
        </ng-container>

        <ng-container matColumnDef="portfolioDocument">
          <th mat-header-cell *matHeaderCellDef>CNPJ</th>
          <td mat-cell *matCellDef="let element">
            {{ element.portfolioDocument }}
          </td>
        </ng-container>

        <ng-container matColumnDef="portfolioAccount">
          <th mat-header-cell *matHeaderCellDef>Conta Corrente</th>
          <td mat-cell *matCellDef="let element">
            {{ element.portfolioAccount }}
          </td>
        </ng-container>

        <!-- specifics -->

        <ng-container matColumnDef="portfolioB3Account">
          <th mat-header-cell *matHeaderCellDef>Conta B3</th>
          <td mat-cell *matCellDef="let element">
            {{ element.portfolioB3Account }}
          </td>
        </ng-container>

        <ng-container matColumnDef="tradingDate">
          <th mat-header-cell *matHeaderCellDef>Data Pregão</th>
          <td mat-cell *matCellDef="let element">
            {{ element.tradingDate | date : "dd/MM/yyyy" }}
          </td>
        </ng-container>

        <ng-container matColumnDef="operationTypeId">
          <th mat-header-cell *matHeaderCellDef>Tipo Operação</th>
          <td mat-cell *matCellDef="let element">
            {{ OperationTypesDescription[element.operationTypeId] }}
          </td>
        </ng-container>

        <ng-container matColumnDef="paperCode">
          <th mat-header-cell *matHeaderCellDef>Código Papel</th>
          <td mat-cell *matCellDef="let element">
            {{ element.paperCode }}
          </td>
        </ng-container>

        <ng-container matColumnDef="amount">
          <th mat-header-cell *matHeaderCellDef>Quantidade</th>
          <td mat-cell *matCellDef="let element">
            {{ element.amount | number }}
          </td>
        </ng-container>

        <ng-container matColumnDef="broker">
          <th mat-header-cell *matHeaderCellDef>Nome Corretora Contraparte</th>
          <td mat-cell *matCellDef="let element">
            {{ element.broker }}
          </td>
        </ng-container>

        <ng-container matColumnDef="brokerCode">
          <th mat-header-cell *matHeaderCellDef>Código Corretora B3</th>
          <td mat-cell *matCellDef="let element">
            {{ element.brokerCode }}
          </td>
        </ng-container>

        <ng-container matColumnDef="statusId">
          <th mat-header-cell *matHeaderCellDef>Status</th>
          <td mat-cell *matCellDef="let element">
            {{ WorkflowStatusDescription[element.statusId || -1] }}
          </td>
        </ng-container>

        <ng-container matColumnDef="elapsedTime">
          <th mat-header-cell *matHeaderCellDef>Tempo Decorrido</th>
          <td mat-cell *matCellDef="let element">
            <span *ngIf="element.elapsedTime && element.elapsedTime.hours >= 1">
              {{ element.elapsedTime.hours | number : "1.0-0" }}h
            </span>
            <span *ngIf="element.elapsedTime && element.elapsedTime.hours < 1">
              {{ element.elapsedTime.minutes | number : "1.0-0" }}min
            </span>
          </td>
        </ng-container>

        <ng-container matColumnDef="actions" sticky>
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let element" class="actions">
            <div>
              <mat-checkbox
                *ngIf="canCheck(TicketTypeEnum.Futures, element)"
                (click)="$event.stopPropagation()"
                (change)="$event ? SelectionFutures.toggle(element) : null"
                [checked]="SelectionFutures.isSelected(element)"
              >
              </mat-checkbox>
              <a [routerLink]="[MenuConstants.Tickets.Futures, element.id]">
                <fa-icon [icon]="faListAlt" title="Visualizar"></fa-icon>
              </a>
            </div>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="ColumnsFutures; sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: ColumnsFutures"></tr>
      </table>
    </div>
    <paginador
      [listedPages]="futuresListedPages"
      [firstItemOnPage]="futuresFirstItemOnPage"
      [lastItemOnPage]="futuresLastItemOnPage"
      [totalPages]="futuresTotalPages"
      [totalItems]="futuresTotalItems"
      [currentPage]="futuresCurrentPage"
      [itemsPerPage]="[10, 25, 50, 100, 200]"
      (onSearch)="loadFuturesPaged($event[0], $event[1])"
    ></paginador>
  </mat-expansion-panel>

  <mat-expansion-panel
    *ngIf="canDisplay(TicketTypeEnum.SwapCetip)"
    [expanded]="this.ActiveTicketId == TicketTypeEnum.SwapCetip"
  >
    <mat-expansion-panel-header>
      Swap CETIP - ({{ this.SwapCetip ? this.swapCetipTotalItems : 0 }})
    </mat-expansion-panel-header>

    <mat-action-row>
      <button
        *ngIf="hasForwardRole(TicketTypeEnum.SwapCetip)"
        mat-raised-button
        color="primary"
        type="submit"
        (click)="forwardMany(TicketTypeEnum.SwapCetip)"
      >
        Encaminhar
      </button>
      <button
        *ngIf="hasApproveRole(TicketTypeEnum.SwapCetip)"
        mat-raised-button
        color="primary"
        type="submit"
        (click)="approveMany(TicketTypeEnum.SwapCetip)"
      >
        Aprovar
      </button>
      <button
        *ngIf="hasApproveRole(TicketTypeEnum.SwapCetip)"
        mat-raised-button
        color="primary"
        type="submit"
        (click)="rejectMany(TicketTypeEnum.SwapCetip)"
      >
        Reprovar
      </button>
    </mat-action-row>

    <div class="table-container">
      <table mat-table [dataSource]="SwapCetip" class="mat-elevation-z8 col-12">
        <ng-container matColumnDef="id">
          <th mat-header-cell *matHeaderCellDef>Nº</th>
          <td mat-cell *matCellDef="let element">{{ element.id }}</td>
        </ng-container>

        <ng-container matColumnDef="accountManagerName">
          <th mat-header-cell *matHeaderCellDef>Nome do Gestor</th>
          <td mat-cell *matCellDef="let element">
            {{ element.accountManagerName }}
          </td>
        </ng-container>

        <ng-container matColumnDef="accountManagerDocument">
          <th mat-header-cell *matHeaderCellDef>CNPJ Gestor</th>
          <td mat-cell *matCellDef="let element">
            {{ element.accountManagerDocument }}
          </td>
        </ng-container>

        <ng-container matColumnDef="operationDate">
          <th mat-header-cell *matHeaderCellDef>Data Operação</th>
          <td mat-cell *matCellDef="let element">
            {{ element.operationDate | date : "dd/MM/yyyy" }}
          </td>
        </ng-container>

        <ng-container matColumnDef="settlementDate">
          <th mat-header-cell *matHeaderCellDef>Data de Liquidação</th>
          <td mat-cell *matCellDef="let element">
            {{ element.settlementDate | date : "dd/MM/yyyy" }}
          </td>
        </ng-container>

        <ng-container matColumnDef="portfolioName">
          <th mat-header-cell *matHeaderCellDef>Nome do Fundo</th>
          <td mat-cell *matCellDef="let element">
            {{ element.portfolioName }}
          </td>
        </ng-container>

        <ng-container matColumnDef="portfolioDocument">
          <th mat-header-cell *matHeaderCellDef>CNPJ</th>
          <td mat-cell *matCellDef="let element">
            {{ element.portfolioDocument }}
          </td>
        </ng-container>

        <ng-container matColumnDef="portfolioAccount">
          <th mat-header-cell *matHeaderCellDef>Conta Corrente</th>
          <td mat-cell *matCellDef="let element">
            {{ element.portfolioAccount }}
          </td>
        </ng-container>

        <!-- specifics -->

        <ng-container matColumnDef="portfolioCetipAccount">
          <th mat-header-cell *matHeaderCellDef>Conta Cetip</th>
          <td mat-cell *matCellDef="let element">
            {{ element.portfolioCetipAccount }}
          </td>
        </ng-container>

        <ng-container matColumnDef="operationValue">
          <th mat-header-cell *matHeaderCellDef>Valor da Operação</th>
          <td mat-cell *matCellDef="let element">
            {{ element.operationValue | currency : "R$" : "symbol" : "1.2-2" }}
          </td>
        </ng-container>

        <ng-container matColumnDef="counterpartName">
          <th mat-header-cell *matHeaderCellDef>Nome Contraparte</th>
          <td mat-cell *matCellDef="let element">
            {{ element.counterpartName }}
          </td>
        </ng-container>

        <ng-container matColumnDef="counterpartCetipAccount">
          <th mat-header-cell *matHeaderCellDef>Conta Cetip Contraparte</th>
          <td mat-cell *matCellDef="let element">
            {{ element.counterpartCetipAccount }}
          </td>
        </ng-container>

        <ng-container matColumnDef="statusId">
          <th mat-header-cell *matHeaderCellDef>Status</th>
          <td mat-cell *matCellDef="let element">
            {{ WorkflowStatusDescription[element.statusId || -1] }}
          </td>
        </ng-container>

        <ng-container matColumnDef="elapsedTime">
          <th mat-header-cell *matHeaderCellDef>Tempo Decorrido</th>
          <td mat-cell *matCellDef="let element">
            <span *ngIf="element.elapsedTime && element.elapsedTime.hours >= 1">
              {{ element.elapsedTime.hours | number : "1.0-0" }}h
            </span>
            <span *ngIf="element.elapsedTime && element.elapsedTime.hours < 1">
              {{ element.elapsedTime.minutes | number : "1.0-0" }}min
            </span>
          </td>
        </ng-container>

        <ng-container matColumnDef="actions" sticky>
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let element" class="actions">
            <div>
              <mat-checkbox
                *ngIf="canCheck(TicketTypeEnum.SwapCetip, element)"
                (click)="$event.stopPropagation()"
                (change)="$event ? SelectionSwapCetip.toggle(element) : null"
                [checked]="SelectionSwapCetip.isSelected(element)"
              >
              </mat-checkbox>
              <a [routerLink]="[MenuConstants.Tickets.SwapCetip, element.id]">
                <fa-icon [icon]="faListAlt" title="Visualizar"></fa-icon>
              </a>
            </div>
          </td>
        </ng-container>

        <tr
          mat-header-row
          *matHeaderRowDef="ColumnsSwapCetip; sticky: true"
        ></tr>
        <tr mat-row *matRowDef="let row; columns: ColumnsSwapCetip"></tr>
      </table>
    </div>
    <paginador
      [listedPages]="swapCetipListedPages"
      [firstItemOnPage]="swapCetipFirstItemOnPage"
      [lastItemOnPage]="swapCetipLastItemOnPage"
      [totalPages]="swapCetipTotalPages"
      [totalItems]="swapCetipTotalItems"
      [currentPage]="swapCetipCurrentPage"
      [itemsPerPage]="[10, 25, 50, 100, 200]"
      (onSearch)="loadSwapCetipPaged($event[0], $event[1])"
    ></paginador>
  </mat-expansion-panel>

  <mat-expansion-panel
    *ngIf="canDisplay(TicketTypeEnum.Margin)"
    [expanded]="this.ActiveTicketId == TicketTypeEnum.Margin"
  >
    <mat-expansion-panel-header>
      Margem - ({{ this.Margin ? this.marginTotalItems : 0 }})
    </mat-expansion-panel-header>

    <mat-action-row>
      <button
        *ngIf="hasForwardRole(TicketTypeEnum.Margin)"
        mat-raised-button
        color="primary"
        type="submit"
        (click)="forwardMany(TicketTypeEnum.Margin)"
      >
        Encaminhar
      </button>
      <button
        *ngIf="hasApproveRole(TicketTypeEnum.Margin)"
        mat-raised-button
        color="primary"
        type="submit"
        (click)="approveManyLiquidation(TicketTypeEnum.Margin)"
      >
        Aprovar
      </button>
      <button
        *ngIf="hasApproveRole(TicketTypeEnum.Margin)"
        mat-raised-button
        color="primary"
        type="submit"
        (click)="rejectMany(TicketTypeEnum.Margin)"
      >
        Reprovar
      </button>
    </mat-action-row>

    <div class="table-container">
      <table mat-table [dataSource]="Margin" class="mat-elevation-z8 col-12">
        <ng-container matColumnDef="id">
          <th mat-header-cell *matHeaderCellDef>Nº</th>
          <td mat-cell *matCellDef="let element">{{ element.id }}</td>
        </ng-container>

        <ng-container matColumnDef="accountManagerName">
          <th mat-header-cell *matHeaderCellDef>Nome do Gestor</th>
          <td mat-cell *matCellDef="let element">
            {{ element.accountManagerName }}
          </td>
        </ng-container>

        <ng-container matColumnDef="accountManagerDocument">
          <th mat-header-cell *matHeaderCellDef>CNPJ Gestor</th>
          <td mat-cell *matCellDef="let element">
            {{ element.accountManagerDocument }}
          </td>
        </ng-container>

        <ng-container matColumnDef="operationDate">
          <th mat-header-cell *matHeaderCellDef>Data Operação</th>
          <td mat-cell *matCellDef="let element">
            {{ element.operationDate | date : "dd/MM/yyyy" }}
          </td>
        </ng-container>

        <ng-container matColumnDef="settlementDate">
          <th mat-header-cell *matHeaderCellDef>Data de Liquidação</th>
          <td mat-cell *matCellDef="let element">
            {{ element.settlementDate | date : "dd/MM/yyyy" }}
          </td>
        </ng-container>

        <ng-container matColumnDef="portfolioName">
          <th mat-header-cell *matHeaderCellDef>Nome do Fundo</th>
          <td mat-cell *matCellDef="let element">
            {{ element.portfolioName }}
          </td>
        </ng-container>

        <ng-container matColumnDef="portfolioDocument">
          <th mat-header-cell *matHeaderCellDef>CNPJ</th>
          <td mat-cell *matCellDef="let element">
            {{ element.portfolioDocument }}
          </td>
        </ng-container>

        <ng-container matColumnDef="portfolioAccount">
          <th mat-header-cell *matHeaderCellDef>Conta Corrente</th>
          <td mat-cell *matCellDef="let element">
            {{ element.portfolioAccount }}
          </td>
        </ng-container>

        <!-- specifics -->

        <ng-container matColumnDef="portfolioClearingAccount">
          <th mat-header-cell *matHeaderCellDef>Conta Clearing</th>
          <td mat-cell *matCellDef="let element">
            {{ element.portfolioClearingAccount }}
          </td>
        </ng-container>

        <ng-container matColumnDef="operationTypeId">
          <th mat-header-cell *matHeaderCellDef>Tipo Operação</th>
          <td mat-cell *matCellDef="let element">
            {{ OperationTypesDescription[element.operationTypeId] }}
          </td>
        </ng-container>

        <ng-container matColumnDef="marketTypeId">
          <th mat-header-cell *matHeaderCellDef>Tipo Mercado</th>
          <td mat-cell *matCellDef="let element">
            {{ MarketTypesDescription[element.marketTypeId] }}
          </td>
        </ng-container>

        <ng-container matColumnDef="securityName">
          <th mat-header-cell *matHeaderCellDef>Nome Ativo</th>
          <td mat-cell *matCellDef="let element">
            {{ element.securityName || element.securityType || element.asset }}
          </td>
        </ng-container>

        <ng-container matColumnDef="securityCode">
          <th mat-header-cell *matHeaderCellDef>Código Ativo</th>
          <td mat-cell *matCellDef="let element">
            {{ element.securityCode }}
          </td>
        </ng-container>

        <ng-container matColumnDef="operationValue">
          <th mat-header-cell *matHeaderCellDef>Valor da Operação</th>
          <td mat-cell *matCellDef="let element">
            {{ element.operationValue | currency : "R$" : "symbol" : "1.2-2" }}
          </td>
        </ng-container>

        <ng-container matColumnDef="unitPrice">
          <th mat-header-cell *matHeaderCellDef>Preço Unitário</th>
          <td mat-cell *matCellDef="let element">
            {{ element.unitPrice | currency : "R$" : "symbol" : "1.2-2" }}
          </td>
        </ng-container>

        <ng-container matColumnDef="amount">
          <th mat-header-cell *matHeaderCellDef>Quantidade</th>
          <td mat-cell *matCellDef="let element">
            {{ element.amount | number }}
          </td>
        </ng-container>

        <ng-container matColumnDef="expirationDate">
          <th mat-header-cell *matHeaderCellDef>Vencimento Ativo</th>
          <td mat-cell *matCellDef="let element">
            {{ element.expirationDate | date : "dd/MM/yyyy" }}
          </td>
        </ng-container>

        <ng-container matColumnDef="counterpartName">
          <th mat-header-cell *matHeaderCellDef>Nome Corretora Contraparte</th>
          <td mat-cell *matCellDef="let element">
            {{ element.counterpartName }}
          </td>
        </ng-container>

        <ng-container matColumnDef="counterpartClearingAccount">
          <th mat-header-cell *matHeaderCellDef>Conta Corretora Contraparte</th>
          <td mat-cell *matCellDef="let element">
            {{ element.counterpartClearingAccount }}
          </td>
        </ng-container>

        <ng-container matColumnDef="bank">
          <th mat-header-cell *matHeaderCellDef>Banco</th>
          <td mat-cell *matCellDef="let element">
            {{ element.bank }}
          </td>
        </ng-container>

        <ng-container matColumnDef="branch">
          <th mat-header-cell *matHeaderCellDef>Agência</th>
          <td mat-cell *matCellDef="let element">
            {{ element.branch }}
          </td>
        </ng-container>

        <ng-container matColumnDef="account">
          <th mat-header-cell *matHeaderCellDef>Conta</th>
          <td mat-cell *matCellDef="let element">
            {{ element.account }}
          </td>
        </ng-container>

        <ng-container matColumnDef="command">
          <th mat-header-cell *matHeaderCellDef>Comando</th>
          <td mat-cell *matCellDef="let element">
            {{ element.command }}
          </td>
        </ng-container>

        <ng-container matColumnDef="statusId">
          <th mat-header-cell *matHeaderCellDef>Status</th>
          <td mat-cell *matCellDef="let element">
            {{ WorkflowStatusDescription[element.statusId || -1] }}
          </td>
        </ng-container>

        <ng-container matColumnDef="elapsedTime">
          <th mat-header-cell *matHeaderCellDef>Tempo Decorrido</th>
          <td mat-cell *matCellDef="let element">
            <span *ngIf="element.elapsedTime && element.elapsedTime.hours >= 1">
              {{ element.elapsedTime.hours | number : "1.0-0" }}h
            </span>
            <span *ngIf="element.elapsedTime && element.elapsedTime.hours < 1">
              {{ element.elapsedTime.minutes | number : "1.0-0" }}min
            </span>
          </td>
        </ng-container>

        <ng-container matColumnDef="statusElectronicTransferAvailable">
          <th mat-header-cell *matHeaderCellDef>Status TED</th>
          <td mat-cell *matCellDef="let element" class="actions">
            <div *ngIf="element.statusElectronicTransferAvailable">
              <a (click)="transferStatusDialog(element)">
                <fa-icon [icon]="faListAlt" title="Visualizar"></fa-icon>
                {{
                  element.statusElectronicTransferAvailable
                    | scpTicketTransferStatus
                }}
              </a>
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="lastStatusDate">
          <th mat-header-cell *matHeaderCellDef>Última atualização</th>
          <td mat-cell *matCellDef="let element">
            {{ element.lastStatusDate | date : "dd/MM/yyyy HH:mm" }}
          </td>
        </ng-container>

        <ng-container matColumnDef="actions" sticky>
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let element" class="actions">
            <div>
              <mat-checkbox
                *ngIf="canCheck(TicketTypeEnum.Margin, element)"
                (click)="$event.stopPropagation()"
                (change)="$event ? SelectionMargin.toggle(element) : null"
                [checked]="SelectionMargin.isSelected(element)"
              >
              </mat-checkbox>
              <a [routerLink]="[MenuConstants.Tickets.Margin, element.id]">
                <fa-icon [icon]="faListAlt" title="Visualizar"></fa-icon>
              </a>
            </div>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="ColumnsMargin; sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: ColumnsMargin"></tr>
      </table>
    </div>
    <paginador
      [listedPages]="marginListedPages"
      [firstItemOnPage]="marginFirstItemOnPage"
      [lastItemOnPage]="marginLastItemOnPage"
      [totalPages]="marginTotalPages"
      [totalItems]="marginTotalItems"
      [currentPage]="marginCurrentPage"
      [itemsPerPage]="[10, 25, 50, 100, 200]"
      (onSearch)="loadMarginPaged($event[0], $event[1])"
    ></paginador>
  </mat-expansion-panel>

  <mat-expansion-panel
    *ngIf="canDisplay(TicketTypeEnum.CurrencyTerm)"
    [expanded]="this.ActiveTicketId == TicketTypeEnum.CurrencyTerm"
  >
    <mat-expansion-panel-header>
      Termo de Moeda - ({{
        this.CurrencyTerm ? this.currencyTermTotalItems : 0
      }})
    </mat-expansion-panel-header>

    <mat-action-row>
      <button
        *ngIf="hasForwardRole(TicketTypeEnum.CurrencyTerm)"
        mat-raised-button
        color="primary"
        type="submit"
        (click)="forwardMany(TicketTypeEnum.CurrencyTerm)"
      >
        Encaminhar
      </button>
      <button
        *ngIf="hasApproveRole(TicketTypeEnum.CurrencyTerm)"
        mat-raised-button
        color="primary"
        type="submit"
        (click)="approveMany(TicketTypeEnum.CurrencyTerm)"
      >
        Aprovar
      </button>
      <button
        *ngIf="hasApproveRole(TicketTypeEnum.CurrencyTerm)"
        mat-raised-button
        color="primary"
        type="submit"
        (click)="rejectMany(TicketTypeEnum.CurrencyTerm)"
      >
        Reprovar
      </button>
    </mat-action-row>

    <div class="table-container">
      <table
        mat-table
        [dataSource]="CurrencyTerm"
        class="mat-elevation-z8 col-12"
      >
        <ng-container matColumnDef="id">
          <th mat-header-cell *matHeaderCellDef>Nº</th>
          <td mat-cell *matCellDef="let element">{{ element.id }}</td>
        </ng-container>

        <ng-container matColumnDef="accountManagerName">
          <th mat-header-cell *matHeaderCellDef>Nome do Gestor</th>
          <td mat-cell *matCellDef="let element">
            {{ element.accountManagerName }}
          </td>
        </ng-container>

        <ng-container matColumnDef="accountManagerDocument">
          <th mat-header-cell *matHeaderCellDef>CNPJ Gestor</th>
          <td mat-cell *matCellDef="let element">
            {{ element.accountManagerDocument }}
          </td>
        </ng-container>

        <ng-container matColumnDef="operationDate">
          <th mat-header-cell *matHeaderCellDef>Data Operação</th>
          <td mat-cell *matCellDef="let element">
            {{ element.operationDate | date : "dd/MM/yyyy" }}
          </td>
        </ng-container>

        <ng-container matColumnDef="settlementDate">
          <th mat-header-cell *matHeaderCellDef>Data de Liquidação</th>
          <td mat-cell *matCellDef="let element">
            {{ element.settlementDate | date : "dd/MM/yyyy" }}
          </td>
        </ng-container>

        <ng-container matColumnDef="portfolioName">
          <th mat-header-cell *matHeaderCellDef>Nome do Fundo</th>
          <td mat-cell *matCellDef="let element">
            {{ element.portfolio.name }}
          </td>
        </ng-container>

        <ng-container matColumnDef="portfolioDocument">
          <th mat-header-cell *matHeaderCellDef>CNPJ</th>
          <td mat-cell *matCellDef="let element">
            {{ element.portfolio.document }}
          </td>
        </ng-container>

        <ng-container matColumnDef="portfolioAccount">
          <th mat-header-cell *matHeaderCellDef>Conta Corrente</th>
          <td mat-cell *matCellDef="let element">
            {{ element.portfolio.account }}
          </td>
        </ng-container>

        <ng-container matColumnDef="portfolioCetipAccount">
          <th mat-header-cell *matHeaderCellDef>Conta CETIP Carteira</th>
          <td mat-cell *matCellDef="let element">
            {{ element.portfolio.clearingAccount }}
          </td>
        </ng-container>

        <ng-container matColumnDef="operationTypeId">
          <th mat-header-cell *matHeaderCellDef>Tipo Operação</th>
          <td mat-cell *matCellDef="let element">
            {{ OperationTypesDescription[element.operationTypeId] }}
          </td>
        </ng-container>

        <ng-container matColumnDef="operationValue">
          <th mat-header-cell *matHeaderCellDef>Valor da Operação</th>
          <td mat-cell *matCellDef="let element">
            {{ element.operationValue | currency : "R$" : "symbol" : "1.2-2" }}
          </td>
        </ng-container>

        <ng-container matColumnDef="counterpartName">
          <th mat-header-cell *matHeaderCellDef>Nome Contraparte</th>
          <td mat-cell *matCellDef="let element">
            {{ element.counterpart.name }}
          </td>
        </ng-container>

        <ng-container matColumnDef="counterpartCetipAccount">
          <th mat-header-cell *matHeaderCellDef>Conta CETIP Contraparte</th>
          <td mat-cell *matCellDef="let element">
            {{ element.counterpart.clearingAccount }}
          </td>
        </ng-container>

        <ng-container matColumnDef="statusId">
          <th mat-header-cell *matHeaderCellDef>Status</th>
          <td mat-cell *matCellDef="let element">
            {{ WorkflowStatusDescription[element.statusId || -1] }}
          </td>
        </ng-container>

        <ng-container matColumnDef="elapsedTime">
          <th mat-header-cell *matHeaderCellDef>Tempo Decorrido</th>
          <td mat-cell *matCellDef="let element">
            <span *ngIf="element.elapsedTime && element.elapsedTime.hours >= 1">
              {{ element.elapsedTime.hours | number : "1.0-0" }}h
            </span>
            <span *ngIf="element.elapsedTime && element.elapsedTime.hours < 1">
              {{ element.elapsedTime.minutes | number : "1.0-0" }}min
            </span>
          </td>
        </ng-container>

        <ng-container matColumnDef="actions" sticky>
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let element" class="actions">
            <div>
              <mat-checkbox
                *ngIf="canCheck(TicketTypeEnum.CurrencyTerm, element)"
                (click)="$event.stopPropagation()"
                (change)="$event ? SelectionCurrencyTerm.toggle(element) : null"
                [checked]="SelectionCurrencyTerm.isSelected(element)"
              >
              </mat-checkbox>
              <a
                [routerLink]="[MenuConstants.Tickets.CurrencyTerm, element.id]"
              >
                <fa-icon [icon]="faListAlt" title="Visualizar"></fa-icon>
              </a>
            </div>
          </td>
        </ng-container>

        <tr
          mat-header-row
          *matHeaderRowDef="ColumnsCurrencyTerm; sticky: true"
        ></tr>
        <tr mat-row *matRowDef="let row; columns: ColumnsCurrencyTerm"></tr>
      </table>
    </div>
    <paginador
      [listedPages]="currencyTermListedPages"
      [firstItemOnPage]="currencyTermFirstItemOnPage"
      [lastItemOnPage]="currencyTermLastItemOnPage"
      [totalPages]="currencyTermTotalPages"
      [totalItems]="currencyTermTotalItems"
      [currentPage]="currencyTermCurrentPage"
      [itemsPerPage]="[10, 25, 50, 100, 200]"
      (onSearch)="loadCurrencyTermPaged($event[0], $event[1])"
    ></paginador>
  </mat-expansion-panel>

  <!-- -->
  <mat-expansion-panel
    *ngIf="canDisplay(TicketTypeEnum.VariableIncome)"
    [expanded]="this.ActiveTicketId == TicketTypeEnum.VariableIncome"
  >
    <mat-expansion-panel-header>
      Renda Variável - ({{
        this.VariableIncome ? this.variableIncomeTotalItems : 0
      }})
    </mat-expansion-panel-header>

    <mat-action-row>
      <button
        *ngIf="hasForwardRole(TicketTypeEnum.VariableIncome)"
        mat-raised-button
        color="primary"
        type="submit"
        (click)="forwardMany(TicketTypeEnum.VariableIncome)"
      >
        Encaminhar
      </button>
      <button
        *ngIf="hasApproveRole(TicketTypeEnum.VariableIncome)"
        mat-raised-button
        color="primary"
        type="submit"
        (click)="approveMany(TicketTypeEnum.VariableIncome)"
      >
        Aprovar
      </button>
    </mat-action-row>

    <div class="table-container">
      <table
        mat-table
        [dataSource]="VariableIncome"
        class="mat-elevation-z8 col-12"
      >
        <ng-container matColumnDef="id">
          <th mat-header-cell *matHeaderCellDef>Nº</th>
          <td mat-cell *matCellDef="let element">{{ element.id }}</td>
        </ng-container>

        <ng-container matColumnDef="accountManagerName">
          <th mat-header-cell *matHeaderCellDef>Nome do Gestor</th>
          <td mat-cell *matCellDef="let element">
            {{ element.accountManagerName }}
          </td>
        </ng-container>

        <ng-container matColumnDef="accountManagerDocument">
          <th mat-header-cell *matHeaderCellDef>CNPJ Gestor</th>
          <td mat-cell *matCellDef="let element">
            {{ element.accountManagerDocument }}
          </td>
        </ng-container>

        <ng-container matColumnDef="operationDate">
          <th mat-header-cell *matHeaderCellDef>Data Operação</th>
          <td mat-cell *matCellDef="let element">
            {{ element.operationDate | date : "dd/MM/yyyy" }}
          </td>
        </ng-container>

        <ng-container matColumnDef="settlementDate">
          <th mat-header-cell *matHeaderCellDef>Data de Liquidação</th>
          <td mat-cell *matCellDef="let element">
            {{ element.settlementDate | date : "dd/MM/yyyy" }}
          </td>
        </ng-container>

        <ng-container matColumnDef="b3Account">
          <th mat-header-cell *matHeaderCellDef>Conta B3</th>
          <td mat-cell *matCellDef="let element">
            {{ element.clientCode }}
          </td>
        </ng-container>

        <ng-container matColumnDef="brokerCode">
          <th mat-header-cell *matHeaderCellDef>Código da Corretora</th>
          <td mat-cell *matCellDef="let element">
            {{ element.brokerCode }}
          </td>
        </ng-container>

        <ng-container matColumnDef="buyTotal">
          <th mat-header-cell *matHeaderCellDef>Compra</th>
          <td mat-cell *matCellDef="let element">
            {{ element.buyTotal | currency : "R$" : "symbol" : "1.2-2" }}
          </td>
        </ng-container>

        <ng-container matColumnDef="sellTotal">
          <th mat-header-cell *matHeaderCellDef>Venda</th>
          <td mat-cell *matCellDef="let element">
            {{ element.sellTotal | currency : "R$" : "symbol" : "1.2-2" }}
          </td>
        </ng-container>

        <ng-container matColumnDef="total">
          <th mat-header-cell *matHeaderCellDef>Compra-Venda</th>
          <td mat-cell *matCellDef="let element">
            {{
              element.buyTotal - element.sellTotal
                | currency : "R$" : "symbol" : "1.2-2"
            }}
          </td>
        </ng-container>

        <ng-container matColumnDef="statusId">
          <th mat-header-cell *matHeaderCellDef>Status</th>
          <td mat-cell *matCellDef="let element">
            {{ WorkflowStatusDescription[element.statusId || -1] }}
          </td>
        </ng-container>

        <ng-container matColumnDef="elapsedTime">
          <th mat-header-cell *matHeaderCellDef>Tempo Decorrido</th>
          <td mat-cell *matCellDef="let element">
            <span *ngIf="element.elapsedTime && element.elapsedTime.hours >= 1">
              {{ element.elapsedTime.hours | number : "1.0-0" }}h
            </span>
            <span *ngIf="element.elapsedTime && element.elapsedTime.hours < 1">
              {{ element.elapsedTime.minutes | number : "1.0-0" }}min
            </span>
          </td>
        </ng-container>

        <ng-container matColumnDef="actions" sticky>
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let element" class="actions">
            <div>
              <mat-checkbox
                *ngIf="canCheck(TicketTypeEnum.VariableIncome, element)"
                (click)="$event.stopPropagation()"
                (change)="
                  $event ? SelectionVariableIncome.toggle(element) : null
                "
                [checked]="SelectionVariableIncome.isSelected(element)"
              >
              </mat-checkbox>
              <a
                [routerLink]="[
                  MenuConstants.Tickets.VariableIncome,
                  element.id
                ]"
              >
                <fa-icon [icon]="faListAlt" title="Visualizar"></fa-icon>
              </a>
            </div>
          </td>
        </ng-container>

        <tr
          mat-header-row
          *matHeaderRowDef="ColumnsVariableIncome; sticky: true"
        ></tr>
        <tr mat-row *matRowDef="let row; columns: ColumnsVariableIncome"></tr>
      </table>
    </div>
    <paginador
      [listedPages]="variableIncomeListedPages"
      [firstItemOnPage]="variableIncomeFirstItemOnPage"
      [lastItemOnPage]="variableIncomeLastItemOnPage"
      [totalPages]="variableIncomeTotalPages"
      [totalItems]="variableIncomeTotalItems"
      [currentPage]="variableIncomeCurrentPage"
      [itemsPerPage]="[10, 25, 50, 100, 200]"
      (onSearch)="loadVariableIncomePaged($event[0], $event[1])"
    ></paginador>
  </mat-expansion-panel>

  <mat-expansion-panel
    *ngIf="canDisplay(TicketTypeEnum.Transfer)"
    [expanded]="this.ActiveTicketId == TicketTypeEnum.Transfer"
  >
    <mat-expansion-panel-header>
      Transferência - ({{ this.Transfer ? this.transferTotalItems : 0 }})
    </mat-expansion-panel-header>

    <mat-action-row>
      <button
        *ngIf="hasForwardRole(TicketTypeEnum.Transfer)"
        mat-raised-button
        color="primary"
        type="submit"
        (click)="forwardMany(TicketTypeEnum.Transfer)"
      >
        Encaminhar
      </button>
      <button
        *ngIf="hasApproveRole(TicketTypeEnum.Transfer)"
        mat-raised-button
        color="primary"
        type="submit"
        (click)="approveMany(TicketTypeEnum.Transfer)"
      >
        Aprovar
      </button>
      <button
        *ngIf="hasApproveRole(TicketTypeEnum.Transfer)"
        mat-raised-button
        color="primary"
        type="submit"
        (click)="rejectMany(TicketTypeEnum.Transfer)"
      >
        Reprovar
      </button>
    </mat-action-row>

    <div class="table-container">
      <table mat-table [dataSource]="Transfer" class="mat-elevation-z8 col-12">
        <ng-container matColumnDef="id">
          <th mat-header-cell *matHeaderCellDef>Nº</th>
          <td mat-cell *matCellDef="let element">{{ element.id }}</td>
        </ng-container>

        <ng-container matColumnDef="accountManagerName">
          <th mat-header-cell *matHeaderCellDef>Nome do Gestor</th>
          <td mat-cell *matCellDef="let element">
            {{ element.accountManagerName }}
          </td>
        </ng-container>

        <ng-container matColumnDef="accountManagerDocument">
          <th mat-header-cell *matHeaderCellDef>CNPJ Gestor</th>
          <td mat-cell *matCellDef="let element">
            {{ element.accountManagerDocument }}
          </td>
        </ng-container>

        <ng-container matColumnDef="operationDate">
          <th mat-header-cell *matHeaderCellDef>Data Operação</th>
          <td mat-cell *matCellDef="let element">
            {{ element.operationDate | date : "dd/MM/yyyy" }}
          </td>
        </ng-container>

        <ng-container matColumnDef="settlementDate">
          <th mat-header-cell *matHeaderCellDef>Data de Liquidação</th>
          <td mat-cell *matCellDef="let element">
            {{ element.settlementDate | date : "dd/MM/yyyy" }}
          </td>
        </ng-container>

        <ng-container matColumnDef="portfolioName">
          <th mat-header-cell *matHeaderCellDef>Nome do Fundo</th>
          <td mat-cell *matCellDef="let element">
            {{ element.portfolioName }}
          </td>
        </ng-container>

        <ng-container matColumnDef="portfolioBank">
          <th mat-header-cell *matHeaderCellDef>Banco Origem</th>
          <td mat-cell *matCellDef="let element">
            {{ element.portfolioBank }}
          </td>
        </ng-container>

        <ng-container matColumnDef="portfolioBranch">
          <th mat-header-cell *matHeaderCellDef>Agência Origem</th>
          <td mat-cell *matCellDef="let element">
            {{ element.portfolioBranch }}
          </td>
        </ng-container>

        <ng-container matColumnDef="portfolioAccount">
          <th mat-header-cell *matHeaderCellDef>Conta Origem</th>
          <td mat-cell *matCellDef="let element">
            {{ element.portfolioAccount }}
          </td>
        </ng-container>

        <!-- specifics -->

        <ng-container matColumnDef="operationTypeId">
          <th mat-header-cell *matHeaderCellDef>Tipo da Operação</th>
          <td mat-cell *matCellDef="let element">
            {{ OperationTypesDescription[element.operationTypeId] }}
          </td>
        </ng-container>

        <ng-container matColumnDef="operationValue">
          <th mat-header-cell *matHeaderCellDef>Valor da Operação</th>
          <td mat-cell *matCellDef="let element">
            {{ element.operationValue | currency : "R$" : "symbol" : "1.2-2" }}
          </td>
        </ng-container>

        <ng-container matColumnDef="receiverBank">
          <th mat-header-cell *matHeaderCellDef>Banco Destino</th>
          <td mat-cell *matCellDef="let element">
            {{ element.receiverBank }}
          </td>
        </ng-container>

        <ng-container matColumnDef="receiverBranch">
          <th mat-header-cell *matHeaderCellDef>Agência Destino</th>
          <td mat-cell *matCellDef="let element">
            {{ element.receiverBranch }}
          </td>
        </ng-container>

        <ng-container matColumnDef="receiverAccount">
          <th mat-header-cell *matHeaderCellDef>Conta Destino</th>
          <td mat-cell *matCellDef="let element">
            {{ element.receiverAccount }}
          </td>
        </ng-container>

        <ng-container matColumnDef="statusId">
          <th mat-header-cell *matHeaderCellDef>Status</th>
          <td mat-cell *matCellDef="let element">
            {{ WorkflowStatusDescription[element.statusId || -1] }}
          </td>
        </ng-container>

        <ng-container matColumnDef="elapsedTime">
          <th mat-header-cell *matHeaderCellDef>Tempo Decorrido</th>
          <td mat-cell *matCellDef="let element">
            <span *ngIf="element.elapsedTime && element.elapsedTime.hours >= 1">
              {{ element.elapsedTime.hours | number : "1.0-0" }}h
            </span>
            <span *ngIf="element.elapsedTime && element.elapsedTime.hours < 1">
              {{ element.elapsedTime.minutes | number : "1.0-0" }}min
            </span>
          </td>
        </ng-container>

        <ng-container matColumnDef="statusElectronicTransferAvailable">
          <th mat-header-cell *matHeaderCellDef>Status TED</th>
          <td mat-cell *matCellDef="let element" class="actions">
            <div *ngIf="element.statusElectronicTransferAvailable">
              <a (click)="transferStatusDialog(element)">
                <fa-icon [icon]="faListAlt" title="Visualizar"></fa-icon>
                {{
                  element.statusElectronicTransferAvailable
                    | scpTicketTransferStatus
                }}
              </a>
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="lastStatusDate">
          <th mat-header-cell *matHeaderCellDef>Última atualização</th>
          <td mat-cell *matCellDef="let element">
            {{ element.lastStatusDate | date : "dd/MM/yyyy HH:mm" }}
          </td>
        </ng-container>

        <ng-container matColumnDef="actions" sticky>
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let element" class="actions">
            <div>
              <mat-checkbox
                *ngIf="canCheck(TicketTypeEnum.Transfer, element)"
                (click)="$event.stopPropagation()"
                (change)="$event ? SelectionTransfer.toggle(element) : null"
                [checked]="SelectionTransfer.isSelected(element)"
              >
              </mat-checkbox>
              <a [routerLink]="[MenuConstants.Tickets.Transfer, element.id]">
                <fa-icon [icon]="faListAlt" title="Visualizar"></fa-icon>
              </a>
            </div>
          </td>
        </ng-container>

        <tr
          mat-header-row
          *matHeaderRowDef="ColumnsTransfer; sticky: true"
        ></tr>
        <tr mat-row *matRowDef="let row; columns: ColumnsTransfer"></tr>
      </table>
    </div>
    <paginador
      [listedPages]="transferListedPages"
      [firstItemOnPage]="transferFirstItemOnPage"
      [lastItemOnPage]="transferLastItemOnPage"
      [totalPages]="transferTotalPages"
      [totalItems]="transferTotalItems"
      [currentPage]="transferCurrentPage"
      [itemsPerPage]="[10, 25, 50, 100, 200]"
      (onSearch)="loadTransferPaged($event[0], $event[1])"
    ></paginador>
  </mat-expansion-panel>

  <mat-expansion-panel
    *ngIf="canDisplay(TicketTypeEnum.Loan)"
    [expanded]="this.ActiveTicketId == TicketTypeEnum.Loan"
  >
    <mat-expansion-panel-header>
      Emprestimo - ({{ this.Loan ? this.loanTotalItems : 0 }})
    </mat-expansion-panel-header>

    <mat-action-row>
      <button
        *ngIf="hasForwardRole(TicketTypeEnum.Loan)"
        mat-raised-button
        color="primary"
        type="submit"
        (click)="forwardMany(TicketTypeEnum.Loan)"
      >
        Encaminhar
      </button>
      <button
        *ngIf="hasApproveRole(TicketTypeEnum.Loan)"
        mat-raised-button
        color="primary"
        type="submit"
        (click)="approveMany(TicketTypeEnum.Loan)"
      >
        Aprovar
      </button>
      <button
        *ngIf="hasApproveRole(TicketTypeEnum.Loan)"
        mat-raised-button
        color="primary"
        type="submit"
        (click)="rejectMany(TicketTypeEnum.Loan)"
      >
        Reprovar
      </button>
    </mat-action-row>

    <div class="table-container">
      <table mat-table [dataSource]="Loan" class="mat-elevation-z8 col-12">
        <ng-container matColumnDef="id">
          <th mat-header-cell *matHeaderCellDef>No Boleta</th>
          <td mat-cell *matCellDef="let element">{{ element.id }}</td>
        </ng-container>

        <ng-container matColumnDef="statusId">
          <th mat-header-cell *matHeaderCellDef>Status</th>
          <td mat-cell *matCellDef="let element">
            {{ WorkflowStatusDescription[element.statusId || -1] }}
          </td>
        </ng-container>

        <ng-container matColumnDef="portfolioName">
          <th mat-header-cell *matHeaderCellDef>Nome Do Fundo</th>
          <td mat-cell *matCellDef="let element">
            {{ element.portfolioName }}
          </td>
        </ng-container>

        <ng-container matColumnDef="portfolioDocument">
          <th mat-header-cell *matHeaderCellDef>CNPJ Fundo</th>
          <td mat-cell *matCellDef="let element">
            {{ element.portfolioDocument }}
          </td>
        </ng-container>

        <ng-container matColumnDef="operationDate">
          <th mat-header-cell *matHeaderCellDef>Data Operação</th>
          <td mat-cell *matCellDef="let element">
            {{ element.operationDate | date : "dd/MM/yyyy" }}
          </td>
        </ng-container>

        <ng-container matColumnDef="settlementDate">
          <th mat-header-cell *matHeaderCellDef>Data de Liquidação</th>
          <td mat-cell *matCellDef="let element">
            {{ element.settlementDate | date : "dd/MM/yyyy" }}
          </td>
        </ng-container>

        <ng-container matColumnDef="broker">
          <th mat-header-cell *matHeaderCellDef>Corretora</th>
          <td mat-cell *matCellDef="let element">
            {{ element.broker }}
          </td>
        </ng-container>

        <ng-container matColumnDef="loanType">
          <th mat-header-cell *matHeaderCellDef>Tipo De Empréstimo</th>
          <td mat-cell *matCellDef="let element">
            {{ element.loanType }}
          </td>
        </ng-container>

        <ng-container matColumnDef="typeAction">
          <th mat-header-cell *matHeaderCellDef>Tipo De Boleta</th>
          <td mat-cell *matCellDef="let element">
            {{ element.typeAction }}
          </td>
        </ng-container>

        <ng-container matColumnDef="finalGraceDate">
          <th mat-header-cell *matHeaderCellDef>Data Final de Carência</th>
          <td mat-cell *matCellDef="let element">
            {{ element.finalGraceDate | date : "dd/MM/yyyy" }}
          </td>
        </ng-container>

        <ng-container matColumnDef="operationTypeId">
          <th mat-header-cell *matHeaderCellDef>Tipo de Operação</th>
          <td mat-cell *matCellDef="let element">
            {{ element.operationTypeId }}
          </td>
        </ng-container>

        <ng-container matColumnDef="elapsedTime">
          <th mat-header-cell *matHeaderCellDef>Tempo Decorrido</th>
          <td mat-cell *matCellDef="let element">
            <span *ngIf="element.elapsedTime && element.elapsedTime.hours >= 1">
              {{ element.elapsedTime.hours | number : "1.0-0" }}h
            </span>
            <span *ngIf="element.elapsedTime && element.elapsedTime.hours < 1">
              {{ element.elapsedTime.minutes | number : "1.0-0" }}min
            </span>
          </td>
        </ng-container>

        <ng-container matColumnDef="actions" sticky>
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let element" class="actions">
            <div>
              <mat-checkbox
                *ngIf="canCheck(TicketTypeEnum.Loan, element)"
                (click)="$event.stopPropagation()"
                (change)="$event ? SelectionLoan.toggle(element) : null"
                [checked]="SelectionLoan.isSelected(element)"
              >
              </mat-checkbox>
              <a [routerLink]="[MenuConstants.Tickets.Loan, element.id]">
                <fa-icon [icon]="faListAlt" title="Visualizar"></fa-icon>
              </a>
            </div>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="ColumnsLoan; sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: ColumnsLoan"></tr>
      </table>
    </div>
    <paginador
      [listedPages]="loanListedPages"
      [firstItemOnPage]="loanFirstItemOnPage"
      [lastItemOnPage]="loanLastItemOnPage"
      [totalPages]="loanTotalPages"
      [totalItems]="loanTotalItems"
      [currentPage]="loanCurrentPage"
      [itemsPerPage]="[10, 25, 50, 100, 200]"
      (onSearch)="loadLoanPaged($event[0], $event[1])"
    ></paginador>
  </mat-expansion-panel>

  <mat-expansion-panel
    *ngIf="canDisplay(TicketTypeEnum.Exchange)"
    [expanded]="this.ActiveTicketId == TicketTypeEnum.Exchange"
  >
    <mat-expansion-panel-header>
      Câmbio - ({{ this.Exchange ? this.exchangeTotalItems : 0 }})
    </mat-expansion-panel-header>

    <mat-action-row>
      <button
        *ngIf="hasForwardRole(TicketTypeEnum.Exchange)"
        mat-raised-button
        color="primary"
        type="submit"
        (click)="forwardMany(TicketTypeEnum.Exchange)"
      >
        Encaminhar
      </button>
      <button
        *ngIf="hasApproveRole(TicketTypeEnum.Exchange)"
        mat-raised-button
        color="primary"
        type="submit"
        (click)="approveMany(TicketTypeEnum.Exchange)"
      >
        Aprovar
      </button>
      <button
        *ngIf="hasApproveRole(TicketTypeEnum.Exchange)"
        mat-raised-button
        color="primary"
        type="submit"
        (click)="rejectMany(TicketTypeEnum.Exchange)"
      >
        Reprovar
      </button>
    </mat-action-row>

    <div class="table-container">
      <table mat-table [dataSource]="Exchange" class="mat-elevation-z8 col-12">
        <ng-container matColumnDef="id">
          <th mat-header-cell *matHeaderCellDef>Nº</th>
          <td mat-cell *matCellDef="let element">{{ element.id }}</td>
        </ng-container>

        <ng-container matColumnDef="accountManagerName">
          <th mat-header-cell *matHeaderCellDef>Nome do Gestor</th>
          <td mat-cell *matCellDef="let element">
            {{ element.accountManagerName }}
          </td>
        </ng-container>

        <ng-container matColumnDef="accountManagerDocument">
          <th mat-header-cell *matHeaderCellDef>CNPJ Gestor</th>
          <td mat-cell *matCellDef="let element">
            {{ element.accountManagerDocument }}
          </td>
        </ng-container>

        <ng-container matColumnDef="operationDate">
          <th mat-header-cell *matHeaderCellDef>Data Operação</th>
          <td mat-cell *matCellDef="let element">
            {{ element.operationDate | date : "dd/MM/yyyy" }}
          </td>
        </ng-container>

        <ng-container matColumnDef="settlementDate">
          <th mat-header-cell *matHeaderCellDef>Data de Liquidação</th>
          <td mat-cell *matCellDef="let element">
            {{ element.settlementDate | date : "dd/MM/yyyy" }}
          </td>
        </ng-container>

        <ng-container matColumnDef="portfolioName">
          <th mat-header-cell *matHeaderCellDef>Nome do Fundo</th>
          <td mat-cell *matCellDef="let element">
            {{ element.portfolioName }}
          </td>
        </ng-container>

        <ng-container matColumnDef="portfolioDocument">
          <th mat-header-cell *matHeaderCellDef>CNPJ</th>
          <td mat-cell *matCellDef="let element">
            {{ element.portfolioDocument }}
          </td>
        </ng-container>

        <ng-container matColumnDef="portfolioAccount">
          <th mat-header-cell *matHeaderCellDef>Conta Corrente</th>
          <td mat-cell *matCellDef="let element">
            {{ element.portfolioAccount }}
          </td>
        </ng-container>

        <ng-container matColumnDef="operationTypeId">
          <th mat-header-cell *matHeaderCellDef>Tipo Operação</th>
          <td mat-cell *matCellDef="let element">
            {{ OperationTypesDescription[element.operationTypeId] }}
          </td>
        </ng-container>

        <ng-container matColumnDef="currencyName">
          <th mat-header-cell *matHeaderCellDef>Moeda de Compra/Venda</th>
          <td mat-cell *matCellDef="let element">
            {{ element.currencyName }}
          </td>
        </ng-container>

        <ng-container matColumnDef="operationValue">
          <th mat-header-cell *matHeaderCellDef>Valor da Compra/Venda</th>
          <td mat-cell *matCellDef="let element">
            {{ element.operationValue | currency : "R$" : "symbol" : "1.2-2" }}
          </td>
        </ng-container>

        <ng-container matColumnDef="currencyQuotation">
          <th mat-header-cell *matHeaderCellDef>Cotação</th>
          <td mat-cell *matCellDef="let element">
            {{
              element.currencyQuotation | currency : "R$" : "symbol" : "1.0-6"
            }}
          </td>
        </ng-container>

        <ng-container matColumnDef="parityPl">
          <th mat-header-cell *matHeaderCellDef>Paridade de Avaliação PL</th>
          <td mat-cell *matCellDef="let element">
            {{ element.parityPl }}
          </td>
        </ng-container>

        <ng-container matColumnDef="parityMtm">
          <th mat-header-cell *matHeaderCellDef>Paridade MTM</th>
          <td mat-cell *matCellDef="let element">
            {{ element.parityMtm }}
          </td>
        </ng-container>

        <ng-container matColumnDef="counterpartName">
          <th mat-header-cell *matHeaderCellDef>Contraparte</th>
          <td mat-cell *matCellDef="let element">
            {{ element.counterpartName }}
          </td>
        </ng-container>

        <ng-container matColumnDef="tradingPlace">
          <th mat-header-cell *matHeaderCellDef>Praça de Negociação</th>
          <td mat-cell *matCellDef="let element">
            {{ element.tradingPlace }}
          </td>
        </ng-container>

        <ng-container matColumnDef="settlementPlace">
          <th mat-header-cell *matHeaderCellDef>Praça de Liquidação</th>
          <td mat-cell *matCellDef="let element">
            {{ element.settlementPlace }}
          </td>
        </ng-container>

        <ng-container matColumnDef="appealDate">
          <th mat-header-cell *matHeaderCellDef>Data do Recurso</th>
          <td mat-cell *matCellDef="let element">
            {{ element.appealDate | date : "dd/MM/yyyy" }}
          </td>
        </ng-container>

        <ng-container matColumnDef="expirationDate">
          <th mat-header-cell *matHeaderCellDef>Data de Vencimento</th>
          <td mat-cell *matCellDef="let element">
            {{ element.expirationDate | date : "dd/MM/yyyy" }}
          </td>
        </ng-container>

        <ng-container matColumnDef="contractSaleSettlementDate">
          <th mat-header-cell *matHeaderCellDef>
            Data de Liquidação Venda Contrato
          </th>
          <td mat-cell *matCellDef="let element">
            {{ element.contractSaleSettlementDate | date : "dd/MM/yyyy" }}
          </td>
        </ng-container>

        <ng-container matColumnDef="currencyAmount">
          <th mat-header-cell *matHeaderCellDef>Quantidade de Moeda</th>
          <td mat-cell *matCellDef="let element">
            {{ element.currencyAmount }}
          </td>
        </ng-container>

        <ng-container matColumnDef="statusId">
          <th mat-header-cell *matHeaderCellDef>Status</th>
          <td mat-cell *matCellDef="let element">
            {{ WorkflowStatusDescription[element.statusId || -1] }}
          </td>
        </ng-container>

        <ng-container matColumnDef="elapsedTime">
          <th mat-header-cell *matHeaderCellDef>Tempo Decorrido</th>
          <td mat-cell *matCellDef="let element">
            <span *ngIf="element.elapsedTime && element.elapsedTime.hours >= 1">
              {{ element.elapsedTime.hours | number : "1.0-0" }}h
            </span>
            <span *ngIf="element.elapsedTime && element.elapsedTime.hours < 1">
              {{ element.elapsedTime.minutes | number : "1.0-0" }}min
            </span>
          </td>
        </ng-container>

        <ng-container matColumnDef="actions" sticky>
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let element" class="actions">
            <div>
              <mat-checkbox
                *ngIf="canCheck(TicketTypeEnum.Exchange, element)"
                (click)="$event.stopPropagation()"
                (change)="$event ? SelectionExchange.toggle(element) : null"
                [checked]="SelectionExchange.isSelected(element)"
              >
              </mat-checkbox>
              <a [routerLink]="[MenuConstants.Tickets.Exchange, element.id]">
                <fa-icon [icon]="faListAlt" title="Visualizar"></fa-icon>
              </a>
            </div>
          </td>
        </ng-container>

        <tr
          mat-header-row
          *matHeaderRowDef="ColumnsExchange; sticky: true"
        ></tr>
        <tr mat-row *matRowDef="let row; columns: ColumnsExchange"></tr>
      </table>
    </div>

    <paginador
      [listedPages]="exchangeListedPage"
      [firstItemOnPage]="exchangeFirstItemOnPage"
      [lastItemOnPage]="exchangeLastItemOnPage"
      [totalPages]="exchangeTotalPages"
      [totalItems]="exchangeTotalItems"
      [currentPage]="exchangeCurrentPage"
      [itemsPerPage]="[10, 25, 50, 100, 200]"
      (onSearch)="loadExchangePaged($event[0], $event[1])"
    ></paginador>
  </mat-expansion-panel>

  <mat-expansion-panel
    *ngIf="canDisplay(TicketTypeEnum.Expenses)"
    [expanded]="this.ActiveTicketId == TicketTypeEnum.Expenses"
  >
    <mat-expansion-panel-header>
      Despesas - ({{ this.Expenses ? this.expensesTotalItems : 0 }})
    </mat-expansion-panel-header>

    <mat-action-row>
      <button
        *ngIf="hasForwardRole(TicketTypeEnum.Expenses)"
        mat-raised-button
        color="primary"
        type="submit"
        (click)="forwardMany(TicketTypeEnum.Expenses)"
      >
        Encaminhar
      </button>
      <button
        *ngIf="hasApproveRole(TicketTypeEnum.Expenses)"
        mat-raised-button
        color="primary"
        type="submit"
        (click)="approveMany(TicketTypeEnum.Expenses)"
      >
        Aprovar
      </button>
      <button
        *ngIf="hasApproveRole(TicketTypeEnum.Expenses)"
        mat-raised-button
        color="primary"
        type="submit"
        (click)="rejectMany(TicketTypeEnum.Expenses)"
      >
        Reprovar
      </button>
    </mat-action-row>

    <div class="table-container">
      <table mat-table [dataSource]="Expenses" class="mat-elevation-z8 col-12">
        <ng-container matColumnDef="id">
          <th mat-header-cell *matHeaderCellDef>Nº</th>
          <td mat-cell *matCellDef="let element">{{ element.id }}</td>
        </ng-container>

        <ng-container matColumnDef="accountManagerName">
          <th mat-header-cell *matHeaderCellDef>Nome do Gestor</th>
          <td mat-cell *matCellDef="let element">
            {{ element.accountManagerName }}
          </td>
        </ng-container>

        <ng-container matColumnDef="accountManagerDocument">
          <th mat-header-cell *matHeaderCellDef>CNPJ Gestor</th>
          <td mat-cell *matCellDef="let element">
            {{ element.accountManagerDocument }}
          </td>
        </ng-container>

        <ng-container matColumnDef="operationDate">
          <th mat-header-cell *matHeaderCellDef>Data Operação</th>
          <td mat-cell *matCellDef="let element">
            {{ element.operationDate | date : "dd/MM/yyyy" }}
          </td>
        </ng-container>

        <ng-container matColumnDef="settlementDate">
          <th mat-header-cell *matHeaderCellDef>Data de Liquidação</th>
          <td mat-cell *matCellDef="let element">
            {{ element.settlementDate | date : "dd/MM/yyyy" }}
          </td>
        </ng-container>

        <ng-container matColumnDef="portfolioName">
          <th mat-header-cell *matHeaderCellDef>Nome do Fundo</th>
          <td mat-cell *matCellDef="let element">
            {{ element.portfolioName }}
          </td>
        </ng-container>

        <ng-container matColumnDef="portfolioDocument">
          <th mat-header-cell *matHeaderCellDef>CNPJ</th>
          <td mat-cell *matCellDef="let element">
            {{ element.portfolioDocument }}
          </td>
        </ng-container>

        <ng-container matColumnDef="portfolioAccount">
          <th mat-header-cell *matHeaderCellDef>Conta Corrente</th>
          <td mat-cell *matCellDef="let element">
            {{ element.portfolioAccount }}
          </td>
        </ng-container>

        <ng-container matColumnDef="expenseType">
          <th mat-header-cell *matHeaderCellDef>Tipo Despesa</th>
          <td mat-cell *matCellDef="let element">
            {{ element.expenseType.name }}
          </td>
        </ng-container>

        <ng-container matColumnDef="operationValue">
          <th mat-header-cell *matHeaderCellDef>Valor</th>
          <td mat-cell *matCellDef="let element">
            {{ element.operationValue | currency : "R$" : "symbol" : "1.2-2" }}
          </td>
        </ng-container>

        <ng-container matColumnDef="details">
          <th mat-header-cell *matHeaderCellDef>Detalhes</th>
          <td mat-cell *matCellDef="let element">
            {{ element.details }}
          </td>
        </ng-container>

        <ng-container matColumnDef="statusId">
          <th mat-header-cell *matHeaderCellDef>Status</th>
          <td mat-cell *matCellDef="let element">
            {{ WorkflowStatusDescription[element.statusId || -1] }}
          </td>
        </ng-container>

        <ng-container matColumnDef="elapsedTime">
          <th mat-header-cell *matHeaderCellDef>Tempo Decorrido</th>
          <td mat-cell *matCellDef="let element">
            <span *ngIf="element.elapsedTime && element.elapsedTime.hours >= 1">
              {{ element.elapsedTime.hours | number : "1.0-0" }}h
            </span>
            <span *ngIf="element.elapsedTime && element.elapsedTime.hours < 1">
              {{ element.elapsedTime.minutes | number : "1.0-0" }}min
            </span>
          </td>
        </ng-container>

        <ng-container matColumnDef="statusElectronicTransferAvailable">
          <th mat-header-cell *matHeaderCellDef>Status TED</th>
          <td mat-cell *matCellDef="let element" class="actions">
            <div *ngIf="element.statusElectronicTransferAvailable">
              <a (click)="transferStatusDialog(element)">
                <fa-icon [icon]="faListAlt" title="Visualizar"></fa-icon>
                {{
                  element.statusElectronicTransferAvailable
                    | scpTicketTransferStatus
                }}
              </a>
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="actions" sticky>
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let element" class="actions">
            <div>
              <mat-checkbox
                *ngIf="canCheck(TicketTypeEnum.Expenses, element)"
                (click)="$event.stopPropagation()"
                (change)="$event ? SelectionExpenses.toggle(element) : null"
                [checked]="SelectionExpenses.isSelected(element)"
              >
              </mat-checkbox>
              <a [routerLink]="[MenuConstants.Tickets.Expenses, element.id]">
                <fa-icon [icon]="faListAlt" title="Visualizar"></fa-icon>
              </a>
            </div>
          </td>
        </ng-container>

        <tr
          mat-header-row
          *matHeaderRowDef="ColumnsExpenses; sticky: true"
        ></tr>
        <tr mat-row *matRowDef="let row; columns: ColumnsExpenses"></tr>
      </table>
    </div>
    <paginador
      [listedPages]="expensesListedPages"
      [firstItemOnPage]="expensesFirstItemOnPage"
      [lastItemOnPage]="expensesLastItemOnPage"
      [totalPages]="expensesTotalPages"
      [totalItems]="expensesTotalItems"
      [currentPage]="expensesCurrentPage"
      [itemsPerPage]="[10, 25, 50, 100, 200]"
      (onSearch)="loadExpensesPaged($event[0], $event[1])"
    ></paginador>
  </mat-expansion-panel>

  <mat-expansion-panel
    *ngIf="canDisplay(TicketTypeEnum.Liabilities)"
    [expanded]="this.ActiveTicketId == TicketTypeEnum.Liabilities"
  >
    <mat-expansion-panel-header>
      Passivo - ({{ this.Liabilities ? this.liabilitiesTotalItems : 0 }})
    </mat-expansion-panel-header>
    <mat-action-row>
      <button
        *ngIf="hasForwardRole(TicketTypeEnum.Liabilities)"
        mat-raised-button
        color="primary"
        type="submit"
        (click)="forwardMany(TicketTypeEnum.Liabilities)"
      >
        Encaminhar
      </button>
      <button
        *ngIf="hasApproveRole(TicketTypeEnum.Liabilities)"
        mat-raised-button
        color="primary"
        type="submit"
        (click)="approveManyLiquidation(TicketTypeEnum.Liabilities)"
      >
        Aprovar
      </button>
      <button
        *ngIf="hasApproveRole(TicketTypeEnum.Liabilities)"
        mat-raised-button
        color="primary"
        type="submit"
        (click)="rejectMany(TicketTypeEnum.Liabilities)"
      >
        Reprovar
      </button>
    </mat-action-row>

    <div class="table-container">
      <table mat-table [dataSource]="Liabilities" class="col-12">
        <!--- Note that these columns can be defined in any order.
            The actual rendered columns are set as a property on the row definition" -->

        <!-- Position Column -->
        <ng-container matColumnDef="id">
          <th mat-header-cell *matHeaderCellDef>Nº</th>
          <td mat-cell *matCellDef="let element">{{ element.id }}</td>
        </ng-container>

        <ng-container matColumnDef="accountManagerName">
          <th mat-header-cell *matHeaderCellDef>Nome do Gestor</th>
          <td mat-cell *matCellDef="let element">
            {{ element.accountManagerName }}
          </td>
        </ng-container>

        <ng-container matColumnDef="accountManagerDocument">
          <th mat-header-cell *matHeaderCellDef>CNPJ Gestor</th>
          <td mat-cell *matCellDef="let element">
            {{ element.accountManagerDocument }}
          </td>
        </ng-container>

        <ng-container matColumnDef="operationDate">
          <th mat-header-cell *matHeaderCellDef>Data Operação</th>
          <td mat-cell *matCellDef="let element">
            {{ element.operationDate | date : "dd/MM/yyyy" }}
          </td>
        </ng-container>

        <ng-container matColumnDef="settlementDate">
          <th mat-header-cell *matHeaderCellDef>Data de Liquidação</th>
          <td mat-cell *matCellDef="let element">
            {{ element.settlementDate | date : "dd/MM/yyyy" }}
          </td>
        </ng-container>

        <ng-container matColumnDef="portfolioName">
          <th mat-header-cell *matHeaderCellDef>Nome do Cotista</th>
          <td mat-cell *matCellDef="let element">
            {{ element.portfolioName }}
          </td>
        </ng-container>

        <ng-container matColumnDef="portfolioDocument">
          <th mat-header-cell *matHeaderCellDef>CPF/CNPJ</th>
          <td mat-cell *matCellDef="let element">
            {{ element.portfolioDocument }}
          </td>
        </ng-container>

        <ng-container matColumnDef="portfolioAccount">
          <th mat-header-cell *matHeaderCellDef>Conta Corrente</th>
          <td mat-cell *matCellDef="let element">
            {{ element.portfolioAccount }}
          </td>
        </ng-container>

        <!-- specifics -->

        <ng-container matColumnDef="cetipAccount">
          <th mat-header-cell *matHeaderCellDef>Conta Cetip</th>
          <td mat-cell *matCellDef="let element">
            {{ element.portfolioCetipAccount }}
          </td>
        </ng-container>

        <ng-container matColumnDef="operationTypeId">
          <th mat-header-cell *matHeaderCellDef>Tipo Operação</th>
          <td mat-cell *matCellDef="let element">
            {{ OperationTypesDescription[element.operationTypeId] }}
          </td>
        </ng-container>

        <ng-container matColumnDef="settlementTypeId">
          <th mat-header-cell *matHeaderCellDef>Tipo Liquidação</th>
          <td mat-cell *matCellDef="let element">
            {{ SettlemenTypesDescription[element.settlementTypeId] }}
          </td>
        </ng-container>

        <ng-container matColumnDef="fundName">
          <th mat-header-cell *matHeaderCellDef>Fundo Investido</th>
          <td mat-cell *matCellDef="let element">
            {{ element.fundName }}
          </td>
        </ng-container>

        <ng-container matColumnDef="quotaValue">
          <th mat-header-cell *matHeaderCellDef>Valor da Cota</th>
          <td mat-cell *matCellDef="let element">
            {{ element.quotaValue | currency : "R$" : "symbol" : "1.2-2" }}
          </td>
        </ng-container>

        <ng-container matColumnDef="operationValue">
          <th mat-header-cell *matHeaderCellDef>Valor da Operação</th>
          <td mat-cell *matCellDef="let element">
            {{ element.operationValue | currency : "R$" : "symbol" : "1.2-2" }}
          </td>
        </ng-container>

        <ng-container matColumnDef="amount">
          <th mat-header-cell *matHeaderCellDef>Quantidade</th>
          <td mat-cell *matCellDef="let element">
            {{ element.amount | number }}
          </td>
        </ng-container>

        <!-- <ng-container matColumnDef="mnemonicCode">
          <th mat-header-cell *matHeaderCellDef>Código Mnemônico / CETIP do Fundo</th>
          <td mat-cell *matCellDef="let element">
            {{ element.mnemonicCode }}
          </td>
        </ng-container> -->

        <ng-container matColumnDef="fundBank">
          <th mat-header-cell *matHeaderCellDef>Banco</th>
          <td mat-cell *matCellDef="let element">
            {{ element.fundBank }}
          </td>
        </ng-container>

        <ng-container matColumnDef="fundBranch">
          <th mat-header-cell *matHeaderCellDef>Agência</th>
          <td mat-cell *matCellDef="let element">
            {{ element.fundBranch }}
          </td>
        </ng-container>

        <ng-container matColumnDef="fundAccount">
          <th mat-header-cell *matHeaderCellDef>Conta</th>
          <td mat-cell *matCellDef="let element">
            {{ element.fundAccount }}
          </td>
        </ng-container>

        <ng-container matColumnDef="isNewFund">
          <th mat-header-cell *matHeaderCellDef>É novo fundo no mercado?</th>
          <td mat-cell *matCellDef="let element">
            {{ element.isNewFund ? "SIM" : "NÃO" }}
          </td>
        </ng-container>

        <ng-container matColumnDef="statusId">
          <th mat-header-cell *matHeaderCellDef>Status</th>
          <td mat-cell *matCellDef="let element">
            {{ WorkflowStatusDescription[element.statusId || -1] }}
          </td>
        </ng-container>

        <ng-container matColumnDef="elapsedTime">
          <th mat-header-cell *matHeaderCellDef>Tempo Decorrido</th>
          <td mat-cell *matCellDef="let element">
            <span *ngIf="element.elapsedTime && element.elapsedTime.hours >= 1">
              {{ element.elapsedTime.hours | number : "1.0-0" }}h
            </span>
            <span *ngIf="element.elapsedTime && element.elapsedTime.hours < 1">
              {{ element.elapsedTime.minutes | number : "1.0-0" }}min
            </span>
          </td>
        </ng-container>

        <ng-container matColumnDef="statusElectronicTransferAvailable">
          <th mat-header-cell *matHeaderCellDef>Status TED</th>
          <td mat-cell *matCellDef="let element" class="actions">
            <div *ngIf="element.statusElectronicTransferAvailable">
              <a (click)="transferStatusDialog(element)">
                <fa-icon [icon]="faListAlt" title="Visualizar"></fa-icon>
                {{
                  element.statusElectronicTransferAvailable
                    | scpTicketTransferStatus
                }}
              </a>
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="lastStatusDate">
          <th mat-header-cell *matHeaderCellDef>Última atualização</th>
          <td mat-cell *matCellDef="let element">
            {{ element.lastStatusDate | date : "dd/MM/yyyy HH:mm" }}
          </td>
        </ng-container>

        <ng-container matColumnDef="actions" sticky>
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let element" class="actions">
            <div>
              <mat-checkbox
                *ngIf="canCheck(TicketTypeEnum.Liabilities, element)"
                (click)="$event.stopPropagation()"
                (change)="$event ? SelectionLiabilities.toggle(element) : null"
                [checked]="SelectionLiabilities.isSelected(element)"
              >
              </mat-checkbox>
              <a [routerLink]="[MenuConstants.Tickets.Liabilities, element.id]">
                <fa-icon [icon]="faListAlt" title="Visualizar"></fa-icon>
              </a>
            </div>
          </td>
        </ng-container>

        <tr
          mat-header-row
          *matHeaderRowDef="ColumnsLiabilities; sticky: true"
        ></tr>
        <tr mat-row *matRowDef="let row; columns: ColumnsLiabilities"></tr>
      </table>
    </div>
    <paginador
      [listedPages]="liabilitiesListedPages"
      [firstItemOnPage]="liabilitiesFirstItemOnPage"
      [lastItemOnPage]="liabilitiesLastItemOnPage"
      [totalPages]="liabilitiesTotalPages"
      [totalItems]="liabilitiesTotalItems"
      [currentPage]="liabilitiesCurrentPage"
      [itemsPerPage]="[10, 25, 50, 100, 200]"
      (onSearch)="loadLiabilitiesPaged($event[0], $event[1])"
    ></paginador>
  </mat-expansion-panel>

  <mat-expansion-panel
    *ngIf="canDisplay(TicketTypeEnum.StructuredOperations)"
    [expanded]="this.ActiveTicketId == TicketTypeEnum.StructuredOperations"
  >
    <mat-expansion-panel-header>
      Operações Estruturadas - ({{
        this.StructuredOperations ? this.structuredTotalItems : 0
      }})
    </mat-expansion-panel-header>

    <!-- <mat-action-row>
      <button
        *ngIf="hasForwardRole(TicketTypeEnum.StructuredOperations)"
        mat-raised-button
        color="primary"
        type="submit"
        (click)="forwardMany(TicketTypeEnum.StructuredOperations)"
      >
        Encaminhar
      </button>
      <button
        *ngIf="hasApproveRole(TicketTypeEnum.StructuredOperations)"
        mat-raised-button
        color="primary"
        type="submit"
        (click)="approveMany(TicketTypeEnum.StructuredOperations)"
      >
        Aprovar
      </button>
    </mat-action-row> -->

    <div class="table-container">
      <table
        mat-table
        [dataSource]="StructuredOperations"
        class="mat-elevation-z8 col-12"
      >
        <ng-container matColumnDef="id">
          <th mat-header-cell *matHeaderCellDef>No. Boleta</th>
          <td mat-cell *matCellDef="let element">{{ element.id }}</td>
        </ng-container>

        <ng-container matColumnDef="accountManagerName">
          <th mat-header-cell *matHeaderCellDef>Nome do Gestor</th>
          <td mat-cell *matCellDef="let element">
            {{ element.accountManagerName }}
          </td>
        </ng-container>

        <ng-container matColumnDef="accountManagerDocument">
          <th mat-header-cell *matHeaderCellDef>CNPJ Gestor</th>
          <td mat-cell *matCellDef="let element">
            {{ element.accountManagerDocument }}
          </td>
        </ng-container>

        <ng-container matColumnDef="operationDate">
          <th mat-header-cell *matHeaderCellDef>Data Operação</th>
          <td mat-cell *matCellDef="let element">
            {{ element.operationDate | date : "dd/MM/yyyy" }}
          </td>
        </ng-container>

        <ng-container matColumnDef="portfolioName">
          <th mat-header-cell *matHeaderCellDef>Nome do Fundo</th>
          <td mat-cell *matCellDef="let element">
            {{ element.portfolioName }}
          </td>
        </ng-container>

        <ng-container matColumnDef="portfolioDocument">
          <th mat-header-cell *matHeaderCellDef>CNPJ</th>
          <td mat-cell *matCellDef="let element">
            {{ element.portfolioDocument }}
          </td>
        </ng-container>

        <ng-container matColumnDef="portfolioAccount">
          <th mat-header-cell *matHeaderCellDef>Conta Corrente</th>
          <td mat-cell *matCellDef="let element">
            {{ element.portfolioAccount }}
          </td>
        </ng-container>

        <ng-container matColumnDef="statusId">
          <th mat-header-cell *matHeaderCellDef>Status</th>
          <td mat-cell *matCellDef="let element">
            {{ WorkflowStatusDescription[element.statusId || -1] }}
          </td>
        </ng-container>

        <ng-container matColumnDef="elapsedTime">
          <th mat-header-cell *matHeaderCellDef>Tempo Decorrido</th>
          <td mat-cell *matCellDef="let element">
            <span *ngIf="element.elapsedTime && element.elapsedTime.hours >= 1">
              {{ element.elapsedTime.hours | number : "1.0-0" }}h
            </span>
            <span *ngIf="element.elapsedTime && element.elapsedTime.hours < 1">
              {{ element.elapsedTime.minutes | number : "1.0-0" }}min
            </span>
          </td>
        </ng-container>

        <ng-container matColumnDef="actions" sticky>
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let element" class="actions">
            <div>
              <!-- <mat-checkbox
                *ngIf="
                  !sameGroupHasApproved(element.approvedGroupIds) &&
                  canCheck(TicketTypeEnum.StructuredOperations, element)
                "
                (click)="$event.stopPropagation()"
                (change)="$event ? SelectionStructured.toggle(element) : null"
                [checked]="SelectionStructured.isSelected(element)"
              >
              </mat-checkbox> -->
              <a
                [routerLink]="[
                  MenuConstants.Tickets.StructuredOperations,
                  element.id
                ]"
              >
                <fa-icon [icon]="faListAlt" title="Visualizar"></fa-icon>
              </a>
            </div>
          </td>
        </ng-container>

        <tr
          mat-header-row
          *matHeaderRowDef="ColumnsStructured; sticky: true"
        ></tr>
        <tr mat-row *matRowDef="let row; columns: ColumnsStructured"></tr>
      </table>
    </div>
    <paginador
      [listedPages]="structuredListedPages"
      [firstItemOnPage]="structuredFirstItemOnPage"
      [lastItemOnPage]="structuredLastItemOnPage"
      [totalPages]="structuredTotalPages"
      [totalItems]="structuredTotalItems"
      [currentPage]="structuredCurrentPage"
      [itemsPerPage]="[10, 25, 50, 100, 200]"
      (onSearch)="loadStructuredPaged($event[0], $event[1])"
    ></paginador>
  </mat-expansion-panel>

  <mat-expansion-panel
    *ngIf="canDisplay(TicketTypeEnum.StructuredOperationOrder)"
    [expanded]="this.ActiveTicketId == TicketTypeEnum.StructuredOperationOrder"
  >
    <mat-expansion-panel-header>
      Ordens de Operações Estruturadas a Liquidar - ({{
        this.StructuredOrder ? this.structuredOrderTotalItems : 0
      }})
    </mat-expansion-panel-header>
    <mat-action-row>
      <button
        *ngIf="hasForwardRole(TicketTypeEnum.StructuredOperationOrder)"
        mat-raised-button
        color="primary"
        type="submit"
        (click)="forwardMany(TicketTypeEnum.StructuredOperationOrder)"
      >
        Encaminhar
      </button>
      <button
        *ngIf="hasApproveRole(TicketTypeEnum.StructuredOperationOrder)"
        mat-raised-button
        color="primary"
        type="submit"
        (click)="approveMany(TicketTypeEnum.StructuredOperationOrder)"
      >
        Aprovar
      </button>
    </mat-action-row>

    <div class="table-container">
      <table
        mat-table
        [dataSource]="StructuredOrder"
        class="mat-elevation-z8 col-12"
      >
        <ng-container matColumnDef="id">
          <th mat-header-cell *matHeaderCellDef>Nº</th>
          <td mat-cell *matCellDef="let element">{{ element.id }}</td>
        </ng-container>

        <ng-container matColumnDef="accountManagerName">
          <th mat-header-cell *matHeaderCellDef>Nome do Gestor</th>
          <td mat-cell *matCellDef="let element">
            {{ element.accountManagerName }}
          </td>
        </ng-container>

        <ng-container matColumnDef="accountManagerDocument">
          <th mat-header-cell *matHeaderCellDef>CNPJ Gestor</th>
          <td mat-cell *matCellDef="let element">
            {{ element.accountManagerDocument }}
          </td>
        </ng-container>

        <ng-container matColumnDef="operationDate">
          <th mat-header-cell *matHeaderCellDef>Data Operação</th>
          <td mat-cell *matCellDef="let element">
            {{ element.operationDate | date : "dd/MM/yyyy" }}
          </td>
        </ng-container>

        <ng-container matColumnDef="settlementDate">
          <th mat-header-cell *matHeaderCellDef>Data de Liquidação</th>
          <td mat-cell *matCellDef="let element">
            {{ element.settlementDate | date : "dd/MM/yyyy" }}
          </td>
        </ng-container>

        <ng-container matColumnDef="portfolioName">
          <th mat-header-cell *matHeaderCellDef>Nome do Fundo</th>
          <td mat-cell *matCellDef="let element">
            {{ element.portfolioName }}
          </td>
        </ng-container>

        <ng-container matColumnDef="portfolioDocument">
          <th mat-header-cell *matHeaderCellDef>CNPJ</th>
          <td mat-cell *matCellDef="let element">
            {{ element.portfolioDocument }}
          </td>
        </ng-container>

        <ng-container matColumnDef="portfolioAccount">
          <th mat-header-cell *matHeaderCellDef>Conta Corrente</th>
          <td mat-cell *matCellDef="let element">
            {{ element.portfolioAccount }}
          </td>
        </ng-container>

        <!-- specifics -->

        <ng-container matColumnDef="portfolioCetipAccount">
          <th mat-header-cell *matHeaderCellDef>Conta Cetip</th>
          <td mat-cell *matCellDef="let element">
            {{ element.portfolioCetipAccount }}
          </td>
        </ng-container>

        <ng-container matColumnDef="secondaryMarket">
          <th mat-header-cell *matHeaderCellDef>Mercado Secundário</th>
          <td mat-cell *matCellDef="let element">
            {{ element.secondaryMarket ? "SIM" : "NÃO" }}
          </td>
        </ng-container>

        <ng-container matColumnDef="settlementTypeId">
          <th mat-header-cell *matHeaderCellDef>Tipo Liquidação</th>
          <td mat-cell *matCellDef="let element">
            {{ SettlemenTypesDescription[element.settlementTypeId] }}
          </td>
        </ng-container>

        <ng-container matColumnDef="operationTypeId">
          <th mat-header-cell *matHeaderCellDef>Tipo Operação</th>
          <td mat-cell *matCellDef="let element">
            {{ OperationTypesDescription[element.operationTypeId] }}
          </td>
        </ng-container>

        <ng-container matColumnDef="operationValue">
          <th mat-header-cell *matHeaderCellDef>Valor Operação</th>
          <td mat-cell *matCellDef="let element">
            {{ element.operationValue | currency : "R$" : "symbol" : "1.2-2" }}
          </td>
        </ng-container>

        <ng-container matColumnDef="unitPrice">
          <th mat-header-cell *matHeaderCellDef>Preço Unitário</th>
          <td mat-cell *matCellDef="let element">
            {{ element.unitPrice | currency : "R$" : "symbol" : "1.2-2" }}
          </td>
        </ng-container>

        <ng-container matColumnDef="amount">
          <th mat-header-cell *matHeaderCellDef>Quantidade</th>
          <td mat-cell *matCellDef="let element">
            {{ element.amount | number }}
          </td>
        </ng-container>

        <ng-container matColumnDef="assetType">
          <th mat-header-cell *matHeaderCellDef>Tipo Ativo</th>
          <td mat-cell *matCellDef="let element">
            {{ element.assetType }}
          </td>
        </ng-container>

        <ng-container matColumnDef="assetCode">
          <th mat-header-cell *matHeaderCellDef>Código Ativo</th>
          <td mat-cell *matCellDef="let element">
            {{ element.assetCode }}
          </td>
        </ng-container>

        <ng-container matColumnDef="expirationDate">
          <th mat-header-cell *matHeaderCellDef>Data Vencimento</th>
          <td mat-cell *matCellDef="let element">
            {{ element.expirationDate | date : "dd/MM/yyyy" }}
          </td>
        </ng-container>

        <ng-container matColumnDef="counterpartName">
          <th mat-header-cell *matHeaderCellDef>Nome Contraparte</th>
          <td mat-cell *matCellDef="let element">
            {{ element.counterpartName }}
          </td>
        </ng-container>

        <ng-container matColumnDef="counterpartCetipAccount">
          <th mat-header-cell *matHeaderCellDef>Conta CETIP Contraparte</th>
          <td mat-cell *matCellDef="let element">
            {{ element.counterpartCetipAccount }}
          </td>
        </ng-container>

        <ng-container matColumnDef="statusId">
          <th mat-header-cell *matHeaderCellDef>Status</th>
          <td mat-cell *matCellDef="let element">
            {{ WorkflowStatusDescription[element.statusId || -1] }}
          </td>
        </ng-container>

        <ng-container matColumnDef="elapsedTime">
          <th mat-header-cell *matHeaderCellDef>Tempo Decorrido</th>
          <td mat-cell *matCellDef="let element">
            <span *ngIf="element.elapsedTime && element.elapsedTime.hours >= 1">
              {{ element.elapsedTime.hours | number : "1.0-0" }}h
            </span>
            <span *ngIf="element.elapsedTime && element.elapsedTime.hours < 1">
              {{ element.elapsedTime.minutes | number : "1.0-0" }}min
            </span>
          </td>
        </ng-container>

        <ng-container matColumnDef="statusElectronicTransferAvailable">
          <th mat-header-cell *matHeaderCellDef>Status TED</th>
          <td mat-cell *matCellDef="let element" class="actions">
            <div *ngIf="element.statusElectronicTransferAvailable">
              <a (click)="transferStatusDialog(element)">
                <fa-icon [icon]="faListAlt" title="Visualizar"></fa-icon>
                {{
                  element.statusElectronicTransferAvailable
                    | scpTicketTransferStatus
                }}
              </a>
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="lastStatusDate">
          <th mat-header-cell *matHeaderCellDef>Última atualização</th>
          <td mat-cell *matCellDef="let element">
            {{ element.lastStatusDate | date : "dd/MM/yyyy HH:mm" }}
          </td>
        </ng-container>

        <ng-container matColumnDef="actions" sticky>
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let element" class="actions">
            <div>
              <mat-checkbox
                *ngIf="
                  canCheck(TicketTypeEnum.StructuredOperationOrder, element)
                "
                (click)="$event.stopPropagation()"
                (change)="
                  $event ? SelectionStructuredOrder.toggle(element) : null
                "
                [checked]="SelectionStructuredOrder.isSelected(element)"
              >
              </mat-checkbox>
              <a
                [routerLink]="[
                  MenuConstants.Tickets.StructuredOperationOrder,
                  element.id
                ]"
              >
                <fa-icon [icon]="faListAlt" title="Visualizar"></fa-icon>
              </a>
            </div>
          </td>
        </ng-container>

        <tr
          mat-header-row
          *matHeaderRowDef="ColumnsStructuredOrder; sticky: true"
        ></tr>
        <tr mat-row *matRowDef="let row; columns: ColumnsStructuredOrder"></tr>
      </table>
    </div>
    <paginador
      [listedPages]="structuredOrderListedPages"
      [firstItemOnPage]="structuredOrderFirstItemOnPage"
      [lastItemOnPage]="structuredOrderLastItemOnPage"
      [totalPages]="structuredOrderTotalPages"
      [totalItems]="structuredOrderTotalItems"
      [currentPage]="structuredOrderCurrentPage"
      [itemsPerPage]="[10, 25, 50, 100, 200]"
      (onSearch)="loadStructuredOrderPaged($event[0], $event[1])"
    ></paginador>
  </mat-expansion-panel>
</mat-accordion>
